<div class="book-appt-outer">
  <div class="book-appt-outer-block" [ngClass]="patientDetials ? 'show-scroll' : 'hide-scroll'">
    <!-- Header top part -->
    <div class="book-appt-outer-block__header">
      <div class="book-appt-outer-block__header-left">
        <div class="book-appt-outer-block__patient-name">
          <a class="back-btn main-close" (click)="CloseDialogue()" [ngClass]="confirmDetialsPage ? 'inactive' : 'active'" href="javascript:void(0);">
            <i class="back-new"></i>
          </a>
          <a class="back-btn confirm-close" (click)="onConfirmNextBack()" [ngClass]="confirmDetialsPage ? 'active' : 'inactive'" href="javascript:void(0);">
            <i class="back-new"></i>
          </a>
          <h2>{{ salesOrder?.patientInfo?.crmPatientLastName }}, {{ salesOrder?.patientInfo?.crmPatientFirstName }}</h2>

          <span class="book-appt-outer-block__date-of-birth" pTooltip="{{ salesOrder?.patientInfo?.crmPatientBirthDate | date : appDateFormat.dateFormat }}">
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.5 0.424988C7.6925 0.424988 7.15275 1.00469 6.85355 1.51469C6.5467 2.04084 6.375 2.68259 6.375 3.18749C6.375 3.60739 6.42855 4.18539 6.7422 4.67159C7.0907 5.21049 7.6823 5.52499 8.5 5.52499C9.3177 5.52499 9.9093 5.21049 10.2578 4.67159C10.5723 4.18539 10.625 3.60739 10.625 3.18749C10.625 2.68259 10.4533 2.03999 10.1465 1.51469C9.8481 1.00469 9.3075 0.424988 8.5 0.424988ZM7.65 3.18749C7.65 2.92399 7.75285 2.50324 7.9543 2.15899C8.1651 1.79859 8.36825 1.69999 8.5 1.69999C8.63175 1.69999 8.8349 1.79859 9.0457 2.15899C9.24715 2.50324 9.35 2.92399 9.35 3.18749C9.35 3.53599 9.2973 3.80799 9.18595 3.97969C9.10945 4.09869 8.95645 4.24999 8.5 4.24999C8.0427 4.24999 7.89055 4.09869 7.81405 3.97969C7.70355 3.80799 7.65 3.53599 7.65 3.18749Z"
                fill="#6C6C6C"
              />
              <path
                d="M15.725 8.28756V15.3001H16.3625C16.5316 15.3001 16.6937 15.3672 16.8133 15.4868C16.9328 15.6063 17 15.7685 17 15.9376C17 16.1066 16.9328 16.2688 16.8133 16.3883C16.6937 16.5079 16.5316 16.5751 16.3625 16.5751H0.6375C0.468424 16.5751 0.306274 16.5079 0.186719 16.3883C0.0671649 16.2688 0 16.1066 0 15.9376C0 15.7685 0.0671649 15.6063 0.186719 15.4868C0.306274 15.3672 0.468424 15.3001 0.6375 15.3001H1.275V8.28756C1.275 7.78033 1.4765 7.29388 1.83516 6.93522C2.19382 6.57656 2.68027 6.37506 3.1875 6.37506H13.8125C14.3197 6.37506 14.8062 6.57656 15.1648 6.93522C15.5235 7.29388 15.725 7.78033 15.725 8.28756ZM2.55 8.28756V10.0649L4.62995 11.4079C4.80171 11.5188 5.00181 11.5778 5.20625 11.5778C5.41069 11.5778 5.61079 11.5188 5.78255 11.4079L7.2675 10.4491C7.6336 10.213 8.05839 10.084 8.49394 10.0765C8.92949 10.069 9.35848 10.1833 9.7325 10.4066L11.4402 11.4258C11.6163 11.5309 11.819 11.5829 12.024 11.5753C12.229 11.5678 12.4274 11.5011 12.5953 11.3833L14.45 10.0811V8.28756C14.45 8.11849 14.3828 7.95634 14.2633 7.83678C14.1437 7.71723 13.9816 7.65006 13.8125 7.65006H3.1875C3.01842 7.65006 2.85627 7.71723 2.73672 7.83678C2.61717 7.95634 2.55 8.11849 2.55 8.28756ZM13.328 12.4271C12.9586 12.6863 12.5221 12.8331 12.0711 12.8497C11.6201 12.8663 11.1739 12.752 10.7865 12.5206L9.0797 11.5006C8.90959 11.399 8.71445 11.3469 8.51634 11.3504C8.31822 11.3538 8.12502 11.4126 7.95855 11.5201L6.4736 12.4789C6.09585 12.7227 5.65582 12.8523 5.20625 12.8523C4.75668 12.8523 4.31665 12.7227 3.9389 12.4789L2.55 11.5822V15.3001H14.45V11.6391L13.328 12.4262V12.4271Z"
                fill="#5E5E5E"
              />
            </svg>
          </span>
        </div>

        <div class="book-appt-outer-block__patient-info-block">
          <span>
            <strong>Patient ID:</strong>
            <a href="javascript:void(0)" (click)="onNavigateBrightTreePatientUrl(salesOrder?.patientInfo?.crmRcmBrightreeID)"> {{ salesOrder?.crmPatientId }}</a>
          </span>
          <span>
            <strong>Sales Order ID:</strong>
            <a href="javascript:void(0)" (click)="onNavigateBrightTreeSalesOrderUrl(salesOrder?.crmSalesorderAppId)">{{ salesOrder?.crmSalesorderAppId }}</a>
          </span>
          <span>
            <strong>Branch:</strong>
            <span class="branchname" pTooltip="{{ salesOrder?.crmBranch }}">{{ salesOrder?.crmBranch }}</span>
          </span>

          <span class="time-zone">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14.9987 7.49906V7.49531C14.9987 5.27603 14.0326 3.283 12.4983 1.91243L12.4908 1.90618C12.4719 1.88575 12.4507 1.86752 12.4277 1.85181L12.4265 1.85118C11.0638 0.654692 9.31148 -0.00351966 7.49813 1.41556e-05C5.60328 1.41556e-05 3.87343 0.703734 2.55479 1.86493L2.56291 1.85806C2.54702 1.87011 2.53236 1.88372 2.51917 1.89868V1.89931C1.72644 2.60127 1.09191 3.46367 0.657608 4.42938C0.22331 5.39509 -0.000841735 6.44206 2.37522e-06 7.50094C2.37522e-06 9.71959 0.964922 11.7126 2.49792 13.0838L2.50542 13.0901C2.52527 13.1126 2.54748 13.1329 2.57166 13.1507L2.57291 13.1513C3.9352 14.346 5.6862 15.0033 7.49813 15C9.31851 15.0028 11.077 14.3395 12.4421 13.1351L12.434 13.1419C13.2404 12.4408 13.8869 11.5745 14.3296 10.6019C14.7723 9.62918 15.0009 8.57275 15 7.50406V7.49969L14.9987 7.49906ZM12.2102 12.377C11.8387 12.0765 11.4392 11.8123 11.0172 11.5883L10.9766 11.5683C11.3597 10.4639 11.5903 9.19086 11.6122 7.86655V7.85655H14.2751C14.1853 9.56985 13.4478 11.185 12.2121 12.3751L12.2102 12.377ZM7.85684 11.4364C8.65865 11.4795 9.40797 11.6558 10.0992 11.9426L10.0542 11.9264C9.50046 13.1888 8.72115 14.0563 7.85684 14.2469V11.4364ZM7.85684 10.7214V7.85655H10.8991C10.875 9.04291 10.6693 10.2186 10.2891 11.3426L10.3135 11.2608C9.53761 10.9419 8.71239 10.7596 7.87434 10.722L7.85747 10.7214H7.85684ZM7.85684 7.14158V4.2767C8.7175 4.23742 9.56481 4.04901 10.361 3.71985L10.3116 3.73798C10.6585 4.74981 10.8716 5.91601 10.8991 7.12845V7.14158H7.85684ZM7.85684 3.56173V0.752481C8.72115 0.943098 9.50046 1.80681 10.0542 3.07301C9.40796 3.34174 8.65865 3.51736 7.87497 3.56111L7.85684 3.56173ZM9.64045 1.06184C10.3769 1.30748 11.0656 1.67785 11.6765 2.1568L11.6622 2.14555C11.3853 2.36304 11.0747 2.56803 10.7472 2.74614L10.7122 2.76364C10.4476 2.13913 10.0838 1.56149 9.63482 1.05309L9.64045 1.05997V1.06184ZM7.14066 0.754356V3.56173C6.36978 3.52241 5.61135 3.35118 4.89834 3.05551L4.94334 3.07176C5.49954 1.80931 6.2776 0.942473 7.14191 0.751856L7.14066 0.754356ZM4.28589 2.76177C3.94713 2.5795 3.62434 2.36897 3.32097 2.13242L3.33597 2.14367C3.92913 1.67879 4.59632 1.31708 5.30956 1.07372L5.35705 1.05934C4.91985 1.55397 4.56361 2.11462 4.30152 2.72052L4.28589 2.76114V2.76177ZM7.14191 4.27608V7.14095H4.09966C4.12716 5.91538 4.34026 4.74918 4.71148 3.65548L4.68711 3.73735C5.46271 4.05576 6.28747 4.2378 7.12503 4.27545L7.14191 4.27608ZM7.14191 7.85592V10.7208C6.28125 10.7601 5.43394 10.9485 4.63774 11.2776L4.68711 11.2595C4.34026 10.2483 4.12716 9.08149 4.09966 7.86905V7.85592H7.14191ZM7.14191 11.4358V14.245C6.2776 14.0544 5.49829 13.1907 4.94459 11.9245C5.59079 11.6558 6.3401 11.4808 7.12378 11.437L7.14191 11.4364V11.4358ZM5.3608 13.9357C4.62459 13.6907 3.93589 13.3212 3.32472 12.8432L3.33972 12.8545C3.61657 12.637 3.92717 12.432 4.25465 12.2539L4.28964 12.2364C4.55205 12.8611 4.91588 13.4383 5.36643 13.9444L5.3608 13.9382V13.9357ZM10.7129 12.2357C11.0753 12.4326 11.3859 12.637 11.6778 12.8651L11.6628 12.8538C11.0696 13.3187 10.4024 13.6804 9.68919 13.9238L9.6417 13.9382C10.0789 13.4438 10.4351 12.8833 10.6972 12.2776L10.7129 12.237V12.2357ZM14.2751 7.14158H11.6122C11.593 5.84848 11.3699 4.56651 10.951 3.34299L10.9766 3.42924C11.418 3.19679 11.836 2.92219 12.2246 2.60928L12.2096 2.62052C13.4428 3.80612 14.1805 5.4153 14.2738 7.12345L14.2744 7.14095L14.2751 7.14158ZM2.78852 2.62115C3.14849 2.91364 3.55283 3.18175 3.98154 3.40987L4.02217 3.42986C3.63907 4.53419 3.40847 5.80726 3.38659 7.13158V7.14158H0.723067C0.812867 5.42828 1.55028 3.8131 2.78602 2.62302L2.78789 2.62115H2.78852ZM0.723692 7.85655H3.38659C3.40575 9.14965 3.6289 10.4316 4.04779 11.6551L4.02217 11.5689C3.55283 11.8182 3.14911 12.0864 2.77415 12.3889L2.78914 12.3776C1.55596 11.192 0.818286 9.58282 0.724942 7.87467L0.724317 7.85717L0.723692 7.85655Z"
                fill="#5E5E5E"
              />
            </svg>
            {{ patientTimezone | timezone }}
          </span>
        </div>
      </div>

      <div class="book-appt-outer-block__header-right">
        <a href="javascript:void(0);" class="btn btn--primary show-patient" [ngClass]="patientDetials ? 'active' : 'inactive'" (click)="clickpatientDetials()"
          >Show Patient's Details</a
        >

        <button *ngIf="!isCallStarted && isTwoNumberExist && isPhoneNumberExist" class="btn btn--primary" (click)="PhoneCallOptions.toggle($event)">
          <i class="voice-call-icon-new"></i> Voice Call
        </button>

        <button
          *ngIf="!isCallStarted && !isTwoNumberExist && isPhoneNumberExist && salesOrder.patientInfo.crmPatientPhoneNo"
          class="btn btn--primary"
          (click)="Phonecall(salesOrder?.patientInfo?.crmPatientPhoneNo, salesOrder?.patientInfo?.crmPatientFirstName, salesOrder?.patientInfo?.crmPatientLastName)"
        >
          Voice Call
        </button>

        <button
          *ngIf="!isCallStarted && !isTwoNumberExist && isPhoneNumberExist && salesOrder.patientInfo.crmPatientMobileNumber"
          class="btn btn--primary"
          (click)="Phonecall(salesOrder?.patientInfo?.crmPatientMobileNumber, salesOrder?.patientInfo?.crmPatientFirstName, salesOrder?.patientInfo?.crmPatientLastName)"
        >
          Voice Call
        </button>

        <button *ngIf="isCallStarted" class="btn btn--secondary hangup-call" (click)="Hangup()" pTooltip="Hang Up" tooltipPosition="bottom">
          <svg xmlns="http://www.w3.org/2000/svg" width="20.8" height="20.8" viewBox="0 0 20.8 20.8">
            <g id="phone-off" transform="translate(-1.6 -1.6)">
              <path
                id="Path_7"
                data-name="Path 7"
                d="M19.74,4.26a.89.89,0,0,0-1.26,0L4.26,18.48a.91.91,0,0,0-.26.63.89.89,0,0,0,1.52.63L19.74,5.52a.89.89,0,0,0,0-1.26ZM6.7,14.63A13.29,13.29,0,0,1,4,6.6,2.61,2.61,0,0,1,6.6,4h.33L8,8.64l-.55.29c-.87.45-1.5.78-1.17,1.58a11.57,11.57,0,0,0,1.57,3l1.43-1.42a10.37,10.37,0,0,1-.8-1.42C9.71,10,9.72,10,9.85,9.85a1,1,0,0,0,.26-.92L8.74,3a1,1,0,0,0-.65-.72,3.79,3.79,0,0,0-.72-.18A3.94,3.94,0,0,0,6.6,2,4.6,4.6,0,0,0,2,6.6a15.33,15.33,0,0,0,3.27,9.46Zm15.24,2.01a4.34,4.34,0,0,0-.19-.73,1,1,0,0,0-.72-.65l-6-1.37a1,1,0,0,0-.92.26c-.14.13-.15.14-.8,1.38a10.88,10.88,0,0,1-1.41-.8l-1.43,1.43a11.52,11.52,0,0,0,2.94,1.56c.84.34,1.17-.29,1.62-1.16l.29-.55L20,17.07v.33A2.61,2.61,0,0,1,17.4,20a13.29,13.29,0,0,1-8-2.7L7.94,18.73A15.33,15.33,0,0,0,17.4,22,4.6,4.6,0,0,0,22,17.4,4.77,4.77,0,0,0,21.94,16.64Z"
                stroke-width="0.6"
              />
            </g>
          </svg>
        </button>

        <button
          *ngIf="isCallStarted"
          class="btn btn--secondary hangup-voice-call"
          (click)="HangupVoiceMail()"
          pTooltip="Hang Up &amp; Voice Mail"
          tooltipPosition="bottom"
        >
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="59.528" height="50.855" viewBox="0 0 59.528 50.855">
            <defs>
              <clipPath id="clip-path">
                <rect y="22" width="59.528" height="21.528" fill="none" />
              </clipPath>
            </defs>
            <g id="hang-up-voicemail-new-1" transform="translate(-576.887 50.855)">
              <g id="hang-up-voicemail" transform="translate(581.935 -50.505)">
                <path
                  id="Path_2"
                  data-name="Path 2"
                  d="M59.695,105.965c-2.346,0-4.265,1.473-4.265,3.274v19.623c0,1.8,1.919,3.274,4.265,3.274H73.029l6.244,6.262a8.872,8.872,0,0,0,.8.7c.182.182.354-.036.606-.2l7.156-6.755H100.6c2.346,0,4.265-1.473,4.265-3.274V109.239c0-1.8-1.919-3.274-4.265-3.274Zm0,1.313h40.9c1.431,0,2.554.862,2.554,1.96v19.623c0,1.1-1.123,1.96-2.554,1.96H87.511a1.011,1.011,0,0,0-.554.164l-6.8,6.656-5.43-6.164c0-.174-.1-.2-.176-.33a1.059,1.059,0,0,0-.679-.327H59.695c-1.431,0-2.554-.862-2.554-1.96V109.238c0-1.1,1.123-1.96,2.554-1.96Z"
                  transform="translate(-55.43 -105.965)"
                  stroke="#fff"
                  stroke-width="0.7"
                />
              </g>
              <g id="Scroll_Group_2" data-name="Scroll Group 2" transform="translate(576.887 -43.528)" clip-path="url(#clip-path)" style="isolation: isolate">
                <g id="call" transform="translate(0 29.753) rotate(-45)">
                  <g id="Component_1_1" data-name="Component 1 – 1" transform="translate(0 0)">
                    <path
                      id="Path_8"
                      data-name="Path 8"
                      d="M1.7,16.153A50.637,50.637,0,0,0,11.791,30.372,48.393,48.393,0,0,0,25.883,40.486a16.884,16.884,0,0,0,6.56,1.622A6.038,6.038,0,0,0,36.878,40.5l4.293-4.292a3.551,3.551,0,0,0-.261-4.994L34.584,24.89a3.552,3.552,0,0,0-4.994-.26L27.62,26.6c-.545.408-3.919-.631-7.715-4.426S15.067,15,15.477,14.459l1.972-1.972a3.551,3.551,0,0,0-.261-4.994L10.862,1.167A3.551,3.551,0,0,0,5.867.907L1.575,5.2C-.567,7.341-.523,11.231,1.7,16.153ZM3.667,7.291,7.959,3a.239.239,0,0,1,.165-.047.971.971,0,0,1,.645.308L15.1,9.586c.327.327.355.716.261.81l-1.972,1.972c-2.452,2.452.372,7.841,4.429,11.9a22.34,22.34,0,0,0,6.255,4.543c3.314,1.5,4.957.571,5.642-.114l1.972-1.972c.095-.094.483-.066.81.261l6.325,6.326c.327.327.355.716.261.81L34.786,38.41c-1.191,1.191-4.076.954-7.72-.636A45.418,45.418,0,0,1,13.883,28.28,47.581,47.581,0,0,1,4.4,14.936C2.765,11.323,2.492,8.466,3.667,7.291Z"
                      transform="translate(0 0)"
                      stroke="#b0a3ef"
                      stroke-width=".5"
                    />
                  </g>
                </g>
              </g>
              <g id="voicemail-new-icon" transform="translate(589.755 -55.101)">
                <circle
                  id="Ellipse_1"
                  data-name="Ellipse 1"
                  cx="6.5"
                  cy="6.5"
                  r="6.5"
                  transform="translate(1.245 10.101)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                />
                <circle
                  id="Ellipse_2"
                  data-name="Ellipse 2"
                  cx="6.5"
                  cy="6.5"
                  r="6.5"
                  transform="translate(19.245 10.101)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                />
                <line
                  id="Line_1"
                  data-name="Line 1"
                  x2="19"
                  transform="translate(7.245 23.101)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                />
              </g>
            </g>
          </svg>
        </button>

        <button class="btn btn--accent" (click)="SaveManualCall()"><i class="phone-icon-new"></i> Log Manual Call</button>

        <p-popover #PhoneCallOptions class="selet-call-popup" [appendTo]="'body'" styleClass="z-index-9999">
          <ng-template pTemplate="content">
            <div class="call-overly">
              <form [formGroup]="phoneForm">
                <div class="from__group form__radio-outer phone-number">
                  <p-radioButton
                    itemid="crmPatientMobileNumber"
                    formControlName="selectedPhone"
                    [value]="salesOrder?.patientInfo?.crmPatientMobileNumber"
                    (click)="Phonecall(salesOrder?.patientInfo?.crmPatientMobileNumber, salesOrder?.patientInfo?.crmPatientFirstName, salesOrder?.patientInfo?.crmPatientLastName); PhoneCallOptions.hide()"
                  />
                  <label class="p-radiobutton-label" for="crmPatientMobileNumber">
                    {{salesOrder?.patientInfo?.crmPatientMobileNumber | phone}}
                  </label>
                </div>
                <div class="from__group form__radio-outer mobile-number">
                  <p-radioButton
                    formControlName="selectedPhone"
                    [value]="salesOrder?.patientInfo?.crmPatientPhoneNo"
                    itemid="crmPatientPhoneNo"
                    (click)="Phonecall(salesOrder?.patientInfo?.crmPatientPhoneNo, salesOrder?.patientInfo?.crmPatientFirstName, salesOrder?.patientInfo?.crmPatientLastName); PhoneCallOptions.hide()"
                  />
                  <label class="p-radiobutton-label" for="crmPatientPhoneNo">
                    {{ salesOrder?.patientInfo?.crmPatientPhoneNo | phone }}
                  </label>
                </div>
              </form>
            </div>
          </ng-template>
        </p-popover>

        <a href="javascript:void(0)" class="h-right-action" (click)="filterCLick.toggle($event)">
          <i class="dot-icon"></i>
        </a>

        <p-popover #filterCLick [appendTo]="'body'" styleClass="z-index-9999">
          <div class="quick-link-menu book-appt-quick-link">
            <ul>
              <li class="show-sm" *ngIf="!isCallStarted && isTwoNumberExist && isPhoneNumberExist">
                <a class="invite-schedule" href="javascript:void(0)" (click)="PhoneCallOptions.toggle($event)"> Voice Call </a>
              </li>
              <li class="show-sm" *ngIf="!isCallStarted && !isTwoNumberExist && isPhoneNumberExist && salesOrder.patientInfo.crmPatientPhoneNo">
                <a
                  class="invite-schedule"
                  href="javascript:void(0)"
                  (click)="
                    Phonecall(salesOrder?.patientInfo?.crmPatientPhoneNo, salesOrder?.patientInfo?.crmPatientFirstName, salesOrder?.patientInfo?.crmPatientLastName)
                  "
                >
                  Voice Call
                </a>
              </li>
              <li class="show-sm" *ngIf="!isCallStarted && !isTwoNumberExist && isPhoneNumberExist && salesOrder.patientInfo.crmPatientMobileNumber">
                <a
                  class="invite-schedule"
                  href="javascript:void(0)"
                  (click)="
                    Phonecall(salesOrder?.patientInfo?.crmPatientMobileNumber, salesOrder?.patientInfo?.crmPatientFirstName, salesOrder?.patientInfo?.crmPatientLastName)
                  "
                >
                  Voice Call
                </a>
              </li>
              <li class="show-sm" *ngIf="isCallStarted">
                <a class="invite-schedule" href="javascript:void(0)" (click)="Hangup()">Hang Up</a>
              </li>
              <li class="show-sm" *ngIf="isCallStarted">
                <a class="invite-schedule" href="javascript:void(0)" (click)="HangupVoiceMail()">Hang Up &amp; Voice Mail</a>
              </li>
              <li class="show-sm">
                <a class="invite-schedule" href="javascript:void(0)" (click)="SaveManualCall()"> Log Manual Call </a>
              </li>

              <li>
                <a class="invite-schedule" href="javascript:void(0)" (click)="scheduleCallBack()"> Schedule Call Back </a>
              </li>
              <li *ngIf="false">
                <a class="invite-schedule" href="javascript:void(0)" (click)="showVoiceCallLogs()"> View Voice Call Log </a>
              </li>
              <li *ngIf="false">
                <a class="invite-schedule" href="javascript:void(0)" (click)="showPhoneCallLogs()"> View Phone Call Log </a>
              </li>
              <li *ngIf="!isAppointment">
                <a class="invite-schedule" href="javascript:void(0)" (click)="VoidAppointmentpopup('A')">Void Review</a>
              </li>
              <li *ngIf="!isAppointment">
                <a class="invite-schedule" href="javascript:void(0)" (click)="VoidAppointmentpopup('P')">Void</a>
              </li>
              <li><a class="invite-schedule" href="javascript:void(0)" (click)="SMSSidebar(); filterCLick.hide()">SMS Logs</a></li>
              <li><a class="invite-schedule" href="javascript:void(0)" (click)="EmailSidebar(); filterCLick.hide()">Email Logs</a></li>
            </ul>
          </div>
        </p-popover>
      </div>
    </div>

    <div class="book-appt-outer-block__patient-detials" [ngClass]="patientDetials ? 'active' : 'inactive'">
      <div class="book-appt-outer-block__patient-detials__left">
        <p-tabView class="tab-outer patient-detials-tab">
          <p-tabPanel>
            <ng-template pTemplate="header">General</ng-template>

            <div class="book-appt-outer-block__patient-detials__block">
              <div class="book-appt-outer-block__patient-detials__column" [ngClass]="patientdetailsEdit ? 'edit-box' : ''">
                <div class="title">
                  <h3>Contact</h3>

                  <div class="edit-save-btns">
                    <a href="javascript:void(0);" (click)="patientdetailsEditFields()" class="edit-icon">
                      <i class="edit-icon-new"></i>
                    </a>

                    <a (click)="savePatientGeneralInformation()" class="save-btn">
                      <svg _ngcontent-geu-c199="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path
                          _ngcontent-geu-c199=""
                          fill="#6F64A7"
                          d="M21.21,5.29a1,1,0,0,0-1.42,0L8.5,16.59l-4.29-4.3a1,1,0,0,0-1.42,1.42l5,5a1,1,0,0,0,1.42,0l12-12A1,1,0,0,0,21.21,5.29Z"
                        ></path>
                      </svg>
                    </a>
                    <a href="javascript:void(0);" (click)="cancelPatientGeneralInformation()" class="cancel-btn">
                      <svg _ngcontent-geu-c199="" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path _ngcontent-geu-c199="" d="M13.8755 2.17661L2.12453 13.8234" stroke="#6F64A7" stroke-width="2"></path>
                        <path _ngcontent-geu-c199="" d="M13.8232 13.8755L2.17637 2.12453" stroke="#6F64A7" stroke-width="2"></path>
                      </svg>
                    </a>
                  </div>
                </div>

                <div class="input-feilds-edit">
                  <i class="email-ic-new"></i>
                  <input type="text" class="form__control" [(ngModel)]="patientEmail" pInputText maxlength="100" />
                </div>

                <div class="input-feilds-edit">
                  <i class="phone-icon-new-primary"></i>
                  <p-inputMask mask="999-999-9999" placeholder="-" [(ngModel)]="patientMobileNumber" class="form__phone" pInputText maxlength="15"></p-inputMask>
                </div>
                <div class="input-feilds-edit">
                  <i class="voice-call-icon-new-primary"></i>
                  <p-inputMask mask="999-999-9999" placeholder="-" [(ngModel)]="patientPhone" class="form__phone" pInputText maxlength="15"></p-inputMask>
                </div>
              </div>

              <div class="book-appt-outer-block__patient-detials__column" [ngClass]="patientdetialsEditOrderNone ? 'edit-box' : ''">
                <div class="title">
                  <h3>Order Note</h3>

                  <div class="edit-save-btns">
                    <a href="javascript:void(0);" (click)="showDialogOrderNote()" class="edit-icon">
                      <i class="edit-icon-new"></i>
                    </a>
                  </div>
                </div>

                <div class="input-feilds-edit order-note-scroll">
                  {{ salesOrder?.crmSalesorderOrderNote }}
                </div>
              </div>
              <div class="book-appt-outer-block__patient-detials__column" [ngClass]="patientdetialsDeliveryNote ? 'edit-box' : ''">
                <div class="title">
                  <h3>Delivery Note</h3>
                  <div class="edit-save-btns">
                    <a href="javascript:void(0);" (click)="showDialogDeliveryNote()" class="edit-icon">
                      <i class="edit-icon-new"></i>
                    </a>
                  </div>
                </div>
                <div class="input-feilds-edit order-note-scroll" *ngIf="salesOrder?.crmSalesorderDeliveryNote">
                  {{ salesOrder?.crmSalesorderDeliveryNote }}
                </div>
              </div>
            </div>
          </p-tabPanel>

          <p-tabPanel>
            <ng-template pTemplate="header">Doctor</ng-template>
            <div class="book-appt-outer-block__patient-detials__block">
              <div class="book-appt-outer-block__patient-detials__column" *ngIf="salesOrder?.doctorInfo">
                <div class="title">
                  <h3>{{ salesOrder?.doctorInfo?.crmDoctorLastName }}, {{ salesOrder?.doctorInfo?.crmDoctorFirstName }}</h3>
                </div>

                <div class="input-feilds-edit disable-feild" *ngIf="salesOrder?.doctorInfo?.crmDoctorContactEmailAddress">
                  <i class="email-ic-new"></i>
                  {{ salesOrder?.doctorInfo?.crmDoctorContactEmailAddress }}
                </div>
                <div class="input-feilds-edit disable-feild" *ngIf="salesOrder?.doctorInfo?.crmDoctorContactNo">
                  <i class="voice-call-icon-new-primary"></i>
                  {{ salesOrder?.doctorInfo?.crmDoctorContactNo | slice : 0 : 3 }}-{{ salesOrder?.doctorInfo?.crmDoctorContactNo | slice : 3 : 6 }}
                  <span *ngIf="salesOrder?.doctorInfo?.crmDoctorContactNo">-</span>
                  {{ salesOrder?.doctorInfo?.crmDoctorContactNo | slice : 6 : 10 }}
                </div>
              </div>

              <div class="book-appt-outer-block__patient-detials__column" *ngIf="salesOrder?.doctorInfo?.crmDoctorAddress">
                <div class="title">
                  <h3>Address</h3>
                </div>
                <div class="input-feilds-edit location-block">
                  <i class="location-icon"></i>
                  <span>{{ salesOrder?.doctorInfo?.crmDoctorAddress }}</span>
                </div>
              </div>
            </div>
          </p-tabPanel>
          <p-tabPanel>
            <ng-template pTemplate="header">Insurance</ng-template>

            <div class="book-appt-outer-block__patient-detials__block insurance-info-column">
              <div class="book-appt-outer-block__patient-detials__column" *ngFor="let ins of salesOrder?.salesOrderInsuranceInfo">
                <div class="title">
                  <h3>Primary Insurance</h3>
                </div>

                <div class="insurance-info" *ngIf="ins.crmPayorLevel === 'Primary' || ins.crmPayorLevel === 'Secondary'">
                  <span>
                    <strong>Policy No.</strong>
                    {{ ins?.crmInsurancePolicyNumber || '-' }}
                  </span>
                  <span> <strong>Company</strong> {{ ins?.crmPolicyHolderName || '-' }} </span>

                  <span *ngIf="ins.crmInsurancePolicyEffectiveDate">
                    <strong>Effective Date</strong>
                    {{ ins.crmInsurancePolicyEffectiveDate | date : appDateFormat.dateFormat }}
                  </span>
                  <span *ngIf="!ins.crmInsurancePolicyEffectiveDate"><strong>Effective Date</strong>-</span>

                  <span><strong>Insurance Verified</strong>{{ ins.crmInsuranceVerified ? 'Yes' : 'No' }} </span>
                  <span><strong>Coverage Verified</strong> {{ ins.crmCoverageVerified ? 'Yes' : 'No' }} </span>
                </div>
              </div>
            </div>
          </p-tabPanel>
          <p-tabPanel>
            <ng-template pTemplate="header">Classification</ng-template>
            <div class="book-appt-outer-block__patient-detials__block">
              <div class="book-appt-outer-block__patient-detials__column">
                <div class="title">
                  <h3>Classification Type</h3>
                </div>

                <div class="insurance-info">
                  {{ salesOrder?.crmClassification || '-' }}
                </div>
              </div>

              <div class="book-appt-outer-block__patient-detials__column">
                <div class="title">
                  <h3>Default Duration</h3>
                </div>

                <div class="patient-info-middle">{{ duration }} <i class="info-new" pTooltip="{{ salesOrder?.crmClassificationDescription }}"></i></div>
              </div>
            </div>
          </p-tabPanel>

          <p-tabPanel *ngIf="isPaymentPermission && paymentData()?.enabled">
            <ng-template pTemplate="header">Payment</ng-template>
            <app-payment-information [salesOrderId]="crmSalesOrderId" [detailedView]="true"></app-payment-information>
          </p-tabPanel>
        </p-tabView>
      </div>

      <div class="book-appt-outer-block__patient-detials__right">
        <div class="address-block-box">
          <div class="address-block-box__left">
            <div class="title">
              <h3>Billing Address</h3>
            </div>
            <div class="input-feilds-edit location-block">
              <i class="location-icon"></i>
              {{ salesOrder?.patientInfo?.crmPatientAddress || '-' }}
            </div>
          </div>
          <div class="address-block-box__left delivery-address">
            <div class="title">
              <h3>Delivery Address</h3>
              <a href="javascript:void(0);" (click)="showDialogDeliveryAddress()" class="edit-icon">
                <i class="edit-icon-new"></i>
              </a>
            </div>
            <span class="form__checkbox-outer">
              <p-checkbox inputId="chkBillAdd" [(ngModel)]="sameAsBillingAddress" [binary]="true" (onChange)="handleBillingAddress($event)" />
              <label class="checkbox-text" for="chkBillAdd">Copy from billing address</label>
            </span>
            <div class="input-feilds-edit location-block">
              <i class="location-icon"></i>
              {{ salesOrder?.crmPatientDeliveryAddress || '' }}
            </div>
          </div>
          <div class="address-block-box__right full-width">
            <div class="title">
              <h3>Choose Appointment Location</h3>
            </div>
            <div>
              <div class="radios">
                <span class="form__radio-outer">
                  <p-radioButton inputId="group4" [(ngModel)]="patientsDefaultAppointmentLocation" value="BillingAddress" (onClick)="handleBillingDeliveryAddress()" />
                  <label class="radio-button-text" for="group4">Billing Address</label>
                </span>
                <span class="form__radio-outer">
                  <p-radioButton inputId="group5" [(ngModel)]="patientsDefaultAppointmentLocation" value="DeliveryAddress" (onClick)="handleBillingDeliveryAddress()" />
                  <label class="radio-button-text" for="group5">Delivery Address</label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Content middle part -->
    <div class="show-hide-content" [ngClass]="confirmDetialsPage ? 'inactive' : 'active'">
      <p-scrollPanel styleClass="show-patient-detail-after-scroll">
        <div class="book-appt-outer-block__content" *ngIf="isDeliveryAddressAvailable">
          <div class="select-appointment-type">
            <div class="tab-selection">
              <!-- Select tab -->
              <div class="select-type-visit" *ngIf="isAppoinmentBookByCalendar && (isAppointmentRescheduledPermission || isAppointmentScheduledPermission)">
                <span
                  class="form__radio-outer"
                  *ngIf="isAppoinmentBookByCalendar && (selectedAppointmentTypePopUp == 'Telehealth' || isRemoteAndFacility) && isDrRemoteVisitOnly"
                >
                  <p-radioButton
                    name="group1"
                    value="Telehealth"
                    label="Remote Setup"
                    [(ngModel)]="selectedAppointmentTypePopUp"
                    (onClick)="handleFacilityAndRemoteVisitOptions()"
                  >
                  </p-radioButton>
                  <label class="form__radio-label" for="group1" [ngClass]="{ 'selected-radio-label': selectedAppointmentTypePopUp === 'Telehealth' }">
                    Remote Setup
                  </label>
                </span>
                <span
                  class="form__radio-outer"
                  *ngIf="isAppoinmentBookByCalendar && (selectedAppointmentTypePopUp == 'Facility Visit' || isRemoteAndFacility) && isDrFacilityVisitOnly"
                >
                  <p-radioButton
                    name="group1"
                    value="Facility Visit"
                    label="Facility Visit"
                    [(ngModel)]="selectedAppointmentTypePopUp"
                    (onClick)="handleFacilityAndRemoteVisitOptions()"
                  >
                  </p-radioButton>
                  <label class="form__radio-label" for="group1" [ngClass]="{ 'selected-radio-label': selectedAppointmentTypePopUp === 'Facility Visit' }">
                    Facility Visit
                  </label>
                </span>
                <span class="form__radio-outer" *ngIf="isAppoinmentBookByCalendar && selectedAppointmentTypePopUp == 'Home Visit' && isDrRoadHomeVisitOnly">
                  <p-radioButton name="group1" value="Home Visit" label="Road/Home Visit" [(ngModel)]="selectedAppointmentTypePopUp"> </p-radioButton>
                  <label class="form__radio-label" for="group1" [ngClass]="{ 'selected-radio-label': selectedAppointmentTypePopUp === 'Home Visit' }">
                    Road/Home Visit
                  </label>
                </span>
              </div>
              <div class="select-type-visit" *ngIf="!isAppoinmentBookByCalendar && (isAppointmentRescheduledPermission || isAppointmentScheduledPermission)">
                <span class="form__radio-outer" *ngIf="isDrRemoteVisitOnly">
                  <p-radioButton
                    name="group1"
                    value="Telehealth"
                    label="Remote Setup"
                    [(ngModel)]="selectedAppointmentTypePopUp"
                    (onClick)="handleFacilityVisitOptions()"
                  >
                  </p-radioButton>
                  <label [ngClass]="{ 'selected-radio-label': selectedAppointmentTypePopUp === 'Telehealth' }" class="form__radio-label" for="group1">Remote Setup</label>
                </span>
                <span class="form__radio-outer" *ngIf="isDrFacilityVisitOnly">
                  <p-radioButton
                    name="group1"
                    value="Facility Visit"
                    label="Facility Visit"
                    [(ngModel)]="selectedAppointmentTypePopUp"
                    (onClick)="handleFacilityVisitOptions()"
                  ></p-radioButton>
                  <label [ngClass]="{ 'selected-radio-label': selectedAppointmentTypePopUp === 'Facility Visit' }" class="form__radio-label" for="group1"
                    >Facility Visit</label
                  >
                </span>
                <span class="form__radio-outer" *ngIf="isDrRoadHomeVisitOnly">
                  <p-radioButton
                    name="group1"
                    value="Home Visit"
                    label="Road/Home Visit"
                    [(ngModel)]="selectedAppointmentTypePopUp"
                    (onClick)="handleFacilityVisitOptions()"
                  >
                  </p-radioButton>
                  <label [ngClass]="{ 'selected-radio-label': selectedAppointmentTypePopUp === 'Home Visit' }" class="form__radio-label" for="group1"
                    >Road/Home Visit</label
                  >
                </span>
              </div>
            </div>

            <!-- Facility Visit -->
            <div class="facility-visit-outer">
              <div class="duration-date">
                <div class="duration-date__left">
                  <div class="selectfacility-timezone appointment-type-box">
                    <div class="form__group"
                      *ngIf="isGroupAppointmentFeatureSubscribed && selectedAppointmentTypePopUp !== 'Home Visit'">
                      <p-select class="form__dropdown select-box" [options]="appointmentCategoryOptions" placeholder="Select Type"
                        [(ngModel)]="appointmentCategory" (onChange)="onAppointmentCategoryChange()" optionLabel="name"
                        filter="true"></p-select>
                    </div>
                    <div class="form__group" *ngIf="selectedAppointmentTypePopUp == 'Facility Visit' && isAppointmentTypeAvailable">
                      <p-select
                        pTooltip="Facility"
                        tooltipPosition="top"
                        (onChange)="onFacilityChangeEvent()"
                        class="form__dropdown select-box"
                        [disabled]="isAppoinmentBookByCalendar"
                        filter="true"
                        [options]="selectedFacility"
                        [(ngModel)]="selectedFacilityLocal"
                        optionLabel="crmFacilityName"
                      >
                        <ng-template let-item pTemplate="selectedItem">
                          <span *ngIf="item?.isDoctorFacility"><i class="ic doc"></i>{{ item?.crmFacilityName }}</span>
                          <span *ngIf="!item?.isDoctorFacility">{{ item?.crmFacilityName }}</span>
                        </ng-template>
                        <ng-template let-facility pTemplate="item">
                          <span *ngIf="facility?.isDoctorFacility"><i class="ic doc"></i>{{ facility?.crmFacilityName }}</span>
                          <span *ngIf="!facility?.isDoctorFacility">{{ facility?.crmFacilityName }}</span>
                        </ng-template>
                      </p-select>
                    </div>
                    <div class="form__group" *ngIf="selectedAppointmentTypePopUp == 'Telehealth' && isAppointmentTypeAvailable">
                      <p-select
                        class="form__dropdown select-box"
                        [options]="selectedFacility"
                        placeholder="Select"
                        [disabled]="true"
                        optionLabel="crmFacilityName"
                        filter="true"
                        (onChange)="onRemoteFacilityChangeEvent()"
                        [(ngModel)]="selectedFacilityLocal"
                      >
                      </p-select>
                    </div>
                  </div>

                  <div class="form">
                    <div class="form__group">
                      <p-datepicker
                        class="form__calendars datepicker"
                        [(ngModel)]="facilitySlotDate"
                        [showIcon]="true"
                        placeholder="MM/DD/YYYY"
                        dateFormat="mm/dd/yy"
                        [minDate]="minAllowDateToBookAppoitment"
                        (onSelect)="onDateSelection()"
                        [numberOfMonths]="2"
                        [showOtherMonths]="false"
                        [selectOtherMonths]="false"
                        appendTo="body"
                      >
                      </p-datepicker>
                    </div>

                    <div class="form__group" *ngIf="selectedRemoteAppointmentType != 'SelfGuided'">
                      <p-select
                        class="form__dropdown select-box"
                        pTooltip="Appointment. Duration"
                        tooltipPosition="top"
                        [options]="apptDuration"
                        name="apptDuration"
                        placeholder="Select Appt. Duration"
                        [(ngModel)]="selectedApptDuration"
                        optionLabel="name"
                        (onChange)="onApptDurationChange(false)"
                      >
                      </p-select>
                    </div>
                    <div class="form__group" *ngIf="selectedRemoteAppointmentType == 'SelfGuided'">
                      <p-select
                        class="form__dropdown select-box"
                        [options]="selfGuidedapptDuration"
                        name="apptDuration"
                        placeholder="Select Appt. Duration"
                        [(ngModel)]="selectedselfGuidedApptDuration"
                        optionLabel="name"
                        (onChange)="onSelfGuidedApptDurationChange()"
                      >
                      </p-select>
                    </div>
                  </div>
                </div>

                <div class="duration-date__right" *ngIf="isAppointment">
                  <a href="javascript:void(0)" class="btn btn--secondary" (click)="currentAppointmentDetails()"><i class="arrow-new"></i> Current Appointment Details</a>

                  <div class="current-appointment-details" [ngClass]="currentAppointmentDetailsBox ? 'active' : 'inactive'">
                    <div class="current-appointment-details__block">
                      <span class="current-appointment-details__column first-comun"> Current <br />Appointment Details </span>
                      <span class="current-appointment-details__column">
                        <strong>Status</strong>
                        <p>{{ appointment?.schWIPStatus }}</p>
                      </span>
                      <span class="current-appointment-details__column">
                        <strong>Date</strong>
                        <p>{{ appointment?.schAppointmentDateStartTime | date : appDateFormat.dateFormat }}</p>
                      </span>

                      <span class="current-appointment-details__column">
                        <strong>Time</strong>
                        <p>
                          {{ appointment?.schAppointmentDateStartTime | date : 'shortTime' | lowercase }} |
                          {{ appointment?.appointmentDetailInfo.crmPatientTimeZone | timezone }}
                        </p>
                      </span>

                      <span class="current-appointment-details__column">
                        <strong>Classification</strong>
                        {{ salesOrder?.crmClassification }}
                      </span>

                      <span class="current-appointment-details__column">
                        <strong>Duration</strong>
                        <p>{{ scheduledApptDuration }}</p>
                      </span>
                      <span class="current-appointment-details__column">
                        <strong>Therapist</strong>
                        <p>
                          {{ appointment?.appointmentDetailInfo?.therapistInfo?.appUserLname }}, {{ appointment?.appointmentDetailInfo?.therapistInfo?.appUserFname }}
                        </p>
                      </span>

                      <span class="current-appointment-details__column">
                        <strong>Appt. Type</strong>
                        <p *ngIf="appointment.schAppointmentType == 'Telehealth'">
                          {{ appointment?.schAppointmentTypeDisplayName }} - {{ appointment.schRemoteAppointmentTypeDisplayName }}
                        </p>
                        <p *ngIf="appointment.schAppointmentType != 'Telehealth'">
                          {{ appointment?.schAppointmentTypeDisplayName }}
                        </p>
                      </span>

                      <span class="current-appointment-details__column">
                        <a href="javascript:void(0)" class="h-right-action" (click)="currentAppointmentPenal.toggle($event)">
                          <i class="dot-icon"></i>
                        </a>
                      </span>

                      <span class="current-appointment-details__column close-btn-block">
                        <a href="javascript:void(0)" class="close-btn" (click)="currentAppointmentDetails()">
                          <img src="assets/img/close-new-white.svg" width="15" height="15" alt="close icon" />
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <p-popover #currentAppointmentPenal styleClass="overlaypanel-outer z-index-9999" [appendTo]="'body'">
                <div class="quick-link-menu">
                  <ul>
                    <li *ngIf="appointment?.schWIPStatus != 'Cancel'">
                      <a class="invite-schedule" href="javascript:void(0)" (click)="cancelAppointmentpopup()">Cancel</a>
                    </li>
                    <li *ngIf="appointment?.schWIPStatus != 'Void Review'">
                      <a class="invite-schedule" href="javascript:void(0)" (click)="VoidAppointmentpopup('A')">Void Review</a>
                    </li>
                    <li *ngIf="appointment?.schWIPStatus != 'Void'">
                      <a class="invite-schedule" href="javascript:void(0)" (click)="VoidAppointmentpopup('P')">Void</a>
                    </li>
                  </ul>
                </div>
              </p-popover>

              <div class="select-time" *ngIf="false">
                <div class="selectfacility-timezone">
                  <div class="form" *ngIf="isAppointmentTypeAvailable">
                    <div class="form__group" *ngIf="selectedRemoteAppointmentType != 'SelfGuided'">
                      <!-- <label class="form__label">Appt. Duration</label> -->
                      <p-select
                        class="form__dropdown select-box"
                        pTooltip="Appointment. Duration"
                        tooltipPosition="top"
                        [options]="apptDuration"
                        name="apptDuration"
                        placeholder="Select Appt. Duration"
                        [(ngModel)]="selectedApptDuration"
                        optionLabel="name"
                        (onChange)="onApptDurationChange(false)"
                      >
                      </p-select>
                    </div>
                    <div class="form__group" *ngIf="selectedRemoteAppointmentType == 'SelfGuided'">
                      <!-- <label class="form__label">Appt. Duration</label> -->
                      <p-select
                        class="form__dropdown select-box"
                        [options]="selfGuidedapptDuration"
                        name="apptDuration"
                        placeholder="Select Appt. Duration"
                        [(ngModel)]="selectedselfGuidedApptDuration"
                        optionLabel="name"
                        (onChange)="onSelfGuidedApptDurationChange()"
                      >
                      </p-select>
                    </div>
                  </div>
                </div>
              </div>

              <div class="timeslot-outer-box">
                <div class="timeslot-block" *ngIf="islotAvailable">
                  <div class="timeslot-block__top">
                    <span class="available-timeslot" *ngIf="isAppointmentTypeAvailable && islotAvailableForTheDay">
                      Timeslots - {{ selectedRoadShowDate | date : 'mediumDate' }}
                    </span>

                    <div class="legend-box-sorting">
                      <a
                        class="appt-sort"
                        href="javascript:void(0)"
                        pTooltip="{{ sortingTooltip }}"
                        *ngIf="islotAvailableForTheDay"
                        [ngClass]="isAscendingSort == false ? '' : 'active'"
                        (click)="sortingClick()"
                      >
                        No. Of Booked Appt.
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M0 0.5V1.65556H7.30435V0.5H0ZM10.3478 0.5V11.2975L8.76887 9.79876L7.91304 10.6111L10.5183 13.1031L10.9565 13.5L11.3948 13.1025L14 10.6111L13.1442 9.79876L11.5652 11.2969V0.5H10.3478ZM0 2.81111V3.96667H6.08696V2.81111H0ZM0 5.12222V6.27778H4.86957V5.12222H0ZM0 7.43333V8.58889H3.65217V7.43333H0ZM0 9.74444V10.9H2.43478V9.74444H0ZM0 12.0556V13.2111H1.21739V12.0556H0Z"
                            fill="#6F64A7"
                          />
                        </svg>
                      </a>
                      <ul class="legend-box" *ngIf="isAppointmentTypeAvailable && islotAvailableForTheDay">
                        <li class="empty">Empty Slot</li>
                        <li class="block-slot">Block Slot</li>
                        <li class="booked-slot">Booked Slot</li>
                        <li class="group-slot">Group Slot</li>
                        <li class="break-hours">Break Hours</li>
                      </ul>
                    </div>
                  </div>

                  <div class="timeslot-block__available-slot" *ngIf="islotAvailable">
                    <div *ngIf="islotAvailableForTheDay">
                      <p-scrollPanel styleClass="time-picker-panel-scroll">
                        <div class="time-picker-panel" *ngFor="let therapist of selectedRoadShowTimeSlotTherapistModel">
                          <div class="time-picker-panel-slot-booked">
                            <div class="time-picker-panel__therapist-name">
                              {{ therapist.therapistFullName }}&nbsp;
                              <span class="therapist-states" *ngIf="therapist?.therapistLicenseStates"
                                >(<span class="therapist-states__lic" pTooltip="{{ therapist?.therapistLicenseStates || '' }}">{{
                                  therapist?.therapistLicenseStates || ''
                                }}</span>
                                )
                              </span>
                              <div *ngIf="!isGoogleMap">
                                <span class="time-picker-panel__miles" *ngIf="therapist?.therapistDistanceDisplayValue">{{
                                  therapist?.therapistDistanceDisplayValue || ''
                                }}</span
                                >&nbsp;
                              </div>

                              <!-- <span class="time-picker-panel__miles"
                                *ngIf="therapist?.therapistDistanceDisplayValue && !isGoogleMap">{{therapist?.therapistDistanceDisplayValue
                                ||''}}</span>&nbsp; -->
                            </div>
                            <div class="time-picker-panel-slot-booked__count">({{ therapist?.appointmentCount }}) Appointments Booked</div>
                          </div>

                          <div class="home-facility-names" *ngIf="isGoogleMap">
                            <span class="time-picker-panel__roadhome-visit-location-name" *ngIf="therapist?.therapistDefaultWorkLocation">
                              Start Location : {{ therapist?.therapistDefaultWorkLocation || '' }}
                              <span class="clini-name" *ngIf="therapist?.therapistDefaultWorkLocation == 'Clinic'">{{ therapist?.therapistFacilityName }}</span>
                              <span class="clini-name-location" pTooltip="{{ therapist?.therapistAddress || '' }}">
                                <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    _ngcontent-jqu-c128=""
                                    d="M8.5 1.06406e-08C6.26031 -0.000111977 4.11108 0.883744 2.51945 2.45947C0.927807 4.03519 0.0223969 6.17542 0 8.415C0 14.2375 7.49063 20.7188 7.80938 20.995C8.00183 21.1596 8.24675 21.2501 8.5 21.2501C8.75325 21.2501 8.99817 21.1596 9.19062 20.995C9.5625 20.7188 17 14.2375 17 8.415C16.9776 6.17542 16.0722 4.03519 14.4806 2.45947C12.8889 0.883744 10.7397 -0.000111977 8.5 1.06406e-08ZM8.5 19.5C6.72563 17.8106 2 12.3781 2 8.415C2 6.72425 2.30446 5.10274 3.5 3.90719C4.69554 2.71165 6.80925 1.5 8.5 1.5C10.1908 1.5 11.8123 2.71165 13.0078 3.90719C14.2034 5.10274 15 6.72425 15 8.415C15 12.3463 10.2744 17.8106 8.5 19.5Z"
                                    fill="#6F64A7"
                                  ></path>
                                  <path
                                    _ngcontent-jqu-c128=""
                                    d="M8.5 4.25C7.7645 4.25 7.04552 4.4681 6.43397 4.87672C5.82243 5.28534 5.34579 5.86613 5.06432 6.54565C4.78286 7.22516 4.70922 7.97288 4.85271 8.69424C4.9962 9.41561 5.35037 10.0782 5.87045 10.5983C6.39053 11.1184 7.05314 11.4726 7.77451 11.616C8.49588 11.7595 9.24359 11.6859 9.92311 11.4044C10.6026 11.123 11.1834 10.6463 11.592 10.0348C12.0007 9.42323 12.2188 8.70425 12.2188 7.96875C12.2188 6.98248 11.827 6.0366 11.1296 5.3392C10.4322 4.6418 9.48628 4.25 8.5 4.25ZM8.5 10.0348C8.18479 10.0348 7.87665 9.46903 7.61456 9.29391C7.35247 9.11878 7.1482 8.86987 7.02757 8.57865C6.90694 8.28743 6.87538 7.96698 6.93688 7.65782C6.99837 7.34867 6.43397 7.08331 7.37305 6.8418C7.59594 6.61891 7.46535 6.55781 7.77451 6.49632C8.08367 6.43482 8.81868 6.37569 9.1099 6.49632C9.40112 6.61694 9.65003 6.82122 9.82516 7.08331C10.0003 7.3454 10.0938 7.65354 10.0938 7.96875C10.0938 8.39144 9.92584 8.79682 9.62695 9.0957C9.32807 9.39459 8.92269 10.0348 8.5 10.0348Z"
                                    fill="#6F64A7"
                                  ></path>
                                </svg>
                              </span>
                            </span>
                          </div>

                          <div class="time-picker-panel__row">
                            <a
                              class="time-picker-panel__items"
                              href="javascript:void(0)"
                              (click)="handleTimeSlotTooltipClick($event, item1)"
                              [attr.disabled]="item1.isBlock1 && !(item1.isGroupAppointment && item1.groupAppointmentBookedCount < item1.groupAppointmentMaxCount && !isSlotInPast(item1.startTime))"
                              popoverPosition="top"
                              [ngClass]="
                                item1.isGroupAppointment && item1.groupAppointmentBookedCount < item1.groupAppointmentMaxCount && !isSlotsSelect(item1.startTime, item1.therapistId) && !isSlotInPast(item1.startTime) && (item1.isRemoteAppointment === (selectedAppointmentTypePopUp === 'Telehealth'))
                                  ? 'time-picker-panel__time group-appointment-color'
                                : item1.isGroupAppointment && item1.groupAppointmentBookedCount < item1.groupAppointmentMaxCount && isSlotsSelect(item1.startTime, item1.therapistId) && !isSlotInPast(item1.startTime) && (item1.isRemoteAppointment === (selectedAppointmentTypePopUp === 'Telehealth'))
                                  ? 'time-picker-panel__time active'
                                : item1.isGroupAppointment && item1.groupAppointmentBookedCount < item1.groupAppointmentMaxCount && isSlotsSelect(item1.startTime, item1.therapistId) && isSlotInPast(item1.startTime)
                                  ? 'time-picker-panel__time booked-appointment-color disable'
                                : item1.isGroupAppointment && (item1.groupAppointmentBookedCount >= item1.groupAppointmentMaxCount || isSlotInPast(item1.startTime) || (item1.isRemoteAppointment !== (selectedAppointmentTypePopUp === 'Telehealth')))
                                  ? 'time-picker-panel__time booked-appointment-color disable'
                                : item1.isAppointment && !isSlotsSelect(item1.startTime, item1.therapistId)
                                  ? 'time-picker-panel__time booked-appointment-color'
                                : item1.isAppointment && isSlotsSelect(item1.startTime, item1.therapistId)
                                  ? 'time-picker-panel__time active'
                                : item1.isBlock1 && !item1.isBlock && !item1.isBreak && !isSlotsSelect(item1.startTime, item1.therapistId)
                                  ? 'time-picker-panel__time disable'
                                : item1.isBlock
                                  ? 'time-picker-panel__time block-slot-color disable'
                                : item1.isBreak
                                  ? 'time-picker-panel__time break-hours-color disable'
                                : isSlotDefaultSelected(item1.startTime, item1.therapistId)
                                  ? 'time-picker-panel__time active'
                                : isSlotSelected(item1.startTime, item1.therapistId)
                                  ? 'time-picker-panel__time active'
                                : isSlotsSelect(item1.startTime, item1.therapistId) && item1.isBlock1
                                  ? 'time-picker-panel__time active disable'
                                : isSlotsSelect(item1.startTime, item1.therapistId) && !item1.isBlock1
                                  ? 'time-picker-panel__time active'
                                : isSlotDisabled(item1.startTime)
                                  ? 'time-picker-panel__time disable'
                                : 'time-picker-panel__time'
                              "
                              *ngFor="let item1 of therapist.timeSlotAppointmentInfo"
                            >
                              <!-- (mouseenter)="BlockNameReason.show($event)" -->
                              <!-- (mouseout)="BlockNameReason.hide()" -->

                              <ng-container *ngIf="!item1.isGroupAppointment">
                                {{ item1.startTime | date : 'hh:mm a' | lowercase }}
                              </ng-container>

                              <ng-container *ngIf="item1.isGroupAppointment">
                                {{ item1.startTime | date : 'hh:mm a' | lowercase }} - {{ item1.endTime | date : 'hh:mm a' | lowercase }}
                              </ng-container>

                              <ng-container *ngIf="item1.isGroupAppointment">
                                {{ item1.groupAppointmentBookedCount}}/{{ item1.groupAppointmentMaxCount}}
                              </ng-container>

                              <p-popover appendTo="body" styleClass="appointment-info" #Appointmentinfo class="selet-call-popup home-visit-therapist">
                                <div class="search-box-outer selet-call-popup__outer">
                                  <strong style="text-transform: capitalize; width: 100%; margin-bottom: 5px">{{ selectedAppointmentSlot?.patientFullName }}</strong>
                                  <span>{{ selectedAppointmentSlot?.patientFullAddress }}</span>
                                </div>
                              </p-popover>

                              <p-popover
                                appendTo="body"
                                styleClass="appointment-info"
                                #Blockinfo
                                #BlockNameReason
                                dismissable="true"
                                class="selet-call-popup home-visit-therapist"
                              >
                                <div class="search-box-outer selet-call-popup__outer">
                                  <strong style="text-transform: capitalize; width: 100%; margin-bottom: 5px">{{ BlockedBy }}</strong>
                                  <span>{{ BlockDescription }}</span>
                                </div>
                              </p-popover>

                              <!-- {{item1.blockName}}
                                {{item1.blockReason}} -->
                            </a>
                          </div>

                          <div class="home-facility-names" *ngIf="isGoogleMap">
                            <span class="time-picker-panel__roadhome-visit-location-name" *ngIf="therapist?.therapistDefaultWorkEndLocation">
                              End Location : {{ therapist?.therapistDefaultWorkEndLocation || '' }}
                              <span class="clini-name" *ngIf="therapist?.therapistDefaultWorkEndLocation == 'Clinic'">{{ therapist?.therapistEndFacilityName }}</span>
                              <span class="clini-name-location" pTooltip="{{ therapist?.therapistEndAddress || '' }}">
                                <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    _ngcontent-jqu-c128=""
                                    d="M8.5 1.06406e-08C6.26031 -0.000111977 4.11108 0.883744 2.51945 2.45947C0.927807 4.03519 0.0223969 6.17542 0 8.415C0 14.2375 7.49063 20.7188 7.80938 20.995C8.00183 21.1596 8.24675 21.2501 8.5 21.2501C8.75325 21.2501 8.99817 21.1596 9.19062 20.995C9.5625 20.7188 17 14.2375 17 8.415C16.9776 6.17542 16.0722 4.03519 14.4806 2.45947C12.8889 0.883744 10.7397 -0.000111977 8.5 1.06406e-08ZM8.5 19.5C6.72563 17.8106 2 12.3781 2 8.415C2 6.72425 2.30446 5.10274 3.5 3.90719C4.69554 2.71165 6.80925 1.5 8.5 1.5C10.1908 1.5 11.8123 2.71165 13.0078 3.90719C14.2034 5.10274 15 6.72425 15 8.415C15 12.3463 10.2744 17.8106 8.5 19.5Z"
                                    fill="#6F64A7"
                                  ></path>
                                  <path
                                    _ngcontent-jqu-c128=""
                                    d="M8.5 4.25C7.7645 4.25 7.04552 4.4681 6.43397 4.87672C5.82243 5.28534 5.34579 5.86613 5.06432 6.54565C4.78286 7.22516 4.70922 7.97288 4.85271 8.69424C4.9962 9.41561 5.35037 10.0782 5.87045 10.5983C6.39053 11.1184 7.05314 11.4726 7.77451 11.616C8.49588 11.7595 9.24359 11.6859 9.92311 11.4044C10.6026 11.123 11.1834 10.6463 11.592 10.0348C12.0007 9.42323 12.2188 8.70425 12.2188 7.96875C12.2188 6.98248 11.827 6.0366 11.1296 5.3392C10.4322 4.6418 9.48628 4.25 8.5 4.25ZM8.5 10.0348C8.18479 10.0348 7.87665 9.46903 7.61456 9.29391C7.35247 9.11878 7.1482 8.86987 7.02757 8.57865C6.90694 8.28743 6.87538 7.96698 6.93688 7.65782C6.99837 7.34867 6.43397 7.08331 7.37305 6.8418C7.59594 6.61891 7.46535 6.55781 7.77451 6.49632C8.08367 6.43482 8.81868 6.37569 9.1099 6.49632C9.40112 6.61694 9.65003 6.82122 9.82516 7.08331C10.0003 7.3454 10.0938 7.65354 10.0938 7.96875C10.0938 8.39144 9.92584 8.79682 9.62695 9.0957C9.32807 9.39459 8.92269 10.0348 8.5 10.0348Z"
                                    fill="#6F64A7"
                                  ></path>
                                </svg>
                              </span>
                            </span>
                          </div>
                          <!-- <div class="time-picker-panel__break-hours">(<strong>Break Hours</strong> - 02:00 pm - 03:00 pm)</div> -->
                        </div>
                      </p-scrollPanel>
                    </div>
                    <div class="no-slots-available-selected-week" *ngIf="isAppointmentTypeAvailable && !islotAvailableForTheDay">
                      <span *ngIf="isLicenseCheckEnabled && !isInsuranceStateFound">
                        There is no therapist available having licensed in the state of the Patient’s address.
                      </span>

                      <span *ngIf="!isLicenseCheckEnabled && !isGlobalHoliday">
                        There are no time-slots available/set up on the selected day, please select a different day or location.
                      </span>
                      <span *ngIf="isGlobalHoliday">
                        {{ globalHolidayMsg }}
                      </span>
                      <span *ngIf="!isAvailableSlot && isLicenseCheckEnabled && !isGlobalHoliday && isInsuranceStateFound">
                        There are no time-slots available/set up on the selected day, please select a different day or location.
                      </span>

                      <span *ngIf="!islotAvailable && !islotAvailableForTheDay && !isInsuranceStateFound">
                        There are no time-slots available/set up on the selected day, please select a different day or location.
                      </span>
                      <span *ngIf="islotAvailable && !islotAvailableForTheDay">
                        There are no time-slots available/set up on the selected day, please select a different day or location.
                      </span>
                    </div>
                  </div>
                </div>

                <div class="timeslot-outer-box__right-block" *ngIf="islotAvailable && selectedAppointmentTypePopUp != 'Home Visit'">
                  <p-scrollPanel styleClass="time-picker-panel-scroll-right">
                    <div class="facility-info" *ngIf="selectedAppointmentTypePopUp == 'Facility Visit'">
                      <h3 class="facility-info__title">{{ selectedFacilityLocal?.crmFacilityName }}</h3>
                      <div class="facility-info__miles">{{ selectedFacilityLocal?.crmFacilityDistanceInMiles }}</div>
                      <div class="facility-info__address">
                        <i class="location-icon"></i>
                        {{ selectedFacilityLocal?.crmFacilityAddress || '-' }}
                      </div>

                      <div class="facility-info__timing">
                        <i class="timer-icon"></i>
                        <span *ngIf="facilityAvailableWeekDays?.length > 0 && selectedFacilityWeekDayMinDate">
                          <strong> {{ selectedFacilityWeekDayMinDate?.startTime | date : 'EEE' }}-{{ selectedFacilityWeekDayMaxDate?.startTime | date : 'EEE' }} </strong>
                          {{ selectedFacilityWeekDayMinDate?.startTimeString }}-{{ selectedFacilityWeekDayMinDate?.endTimeString }}
                        </span>
                        <span *ngIf="facilityAvailableWeekend?.length > 0 && selectedFacilityWeekendMinDate">
                          <strong> {{ selectedFacilityWeekendMinDate?.startTime | date : 'EEE' }}-{{ selectedFacilityWeekendMaxDate?.startTime | date : 'EEE' }} </strong>
                          {{ selectedFacilityWeekendMinDate?.startTimeString }}-{{ selectedFacilityWeekendMinDate?.endTimeString }}
                        </span>
                      </div>

                      <div class="facility-info__next-availability">
                        <i class="next-availability-icon"></i>
                        <span class="next-availability-time">
                          <strong>Next Availability</strong>
                          {{ crmFirstAvailableStartDate | date : appDateFormat.dateFormat }}
                        </span>
                      </div>
                    </div>

                    <div class="facility-info" *ngIf="selectedAppointmentTypePopUp == 'Telehealth'">
                      <h3 class="facility-info__title">Choose any option for remote setup</h3>
                      <div class="select-type-remote">
                        <ul>
                          <li class="form__radio-outer" *ngFor="let item of remoteAppointmentTypeModel">
                            <p-radioButton
                              name="group5"
                              value="{{ item.crmRemoteAppointmentType }}"
                              [(ngModel)]="selectedRemoteAppointmentType"
                              (onClick)="manageRemoteAppointment(item.crmRemoteAppointmentType)"
                              inputId="{{ item.crmRemoteAppointmentTitle }}"
                            />
                            <label for="{{ item.crmRemoteAppointmentTitle }}">{{ item.crmRemoteAppointmentTitle }}</label>
                          </li>
                        </ul>
                      </div>

                      <div class="facility-info__next-availability" *ngIf="selectedAppointmentTypePopUp == 'Telehealth'">
                        <i class="next-availability-icon"></i>
                        <span class="next-availability-time">
                          <strong>Next Availability</strong>
                          {{ crmFirstAvailableStartDate | date : appDateFormat.dateFormat }}
                        </span>
                      </div>
                    </div>

                    <div class="facility-info" *ngIf="selectedAppointmentTypePopUp == 'Home Visit'">
                      <div class="facility-info__next-availability">
                        <i class="next-availability-icon"></i>
                        <span class="next-availability-time">
                          <strong>Next Availability</strong>
                          {{ crmFirstAvailableStartDate | date : appDateFormat.dateFormat }}
                        </span>
                      </div>
                    </div>
                  </p-scrollPanel>
                </div>

                <!-- if Google map not show then showing Next Availability-->
                <div class="timeslot-outer-box__right-block" *ngIf="islotAvailable && selectedAppointmentTypePopUp == 'Home Visit' && !isGoogleMap">
                  <div class="facility-info__next-availability">
                    <i class="next-availability-icon"></i>
                    <span class="next-availability-time">
                      <strong>Next Availability</strong>
                      {{ crmFirstAvailableStartDate | date : appDateFormat.dateFormat }}
                    </span>
                  </div>
                </div>
                <!-- Google map code-->
                <div
                  class="timeslot-outer-box__googlemap"
                  *ngIf="selectedAppointmentTypePopUp == 'Home Visit' && islotAvailable && islotAvailableForTheDay && isGoogleMap"
                >
                  <div class="googlemap-scroll">
                    <div class="selected-therapist-name-miles" *ngIf="selectedTherapistName">
                      <h3>Selected Therapist: {{ selectedTherapistName }}</h3>
                      <h3>{{ selectedTherapistCoverageArea }} Miles Coverage Area</h3>
                    </div>

                    <div class="facility-appointment-info">
                      <div class="start-location-next-location">
                        <!-- *ngIf="startLocationPatient" -->
                        <div class="start-location-next-location__location-box">
                          <span>Start Location :</span> {{ startLocationPatient }}
                          <span class="location-icon-box" pTooltip="{{ startLocationAddress }} " tooltipStyleClass="large-tooltip-outer">
                            <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M8.5 1.06406e-08C6.26031 -0.000111977 4.11108 0.883744 2.51945 2.45947C0.927807 4.03519 0.0223969 6.17542 0 8.415C0 14.2375 7.49063 20.7188 7.80938 20.995C8.00183 21.1596 8.24675 21.2501 8.5 21.2501C8.75325 21.2501 8.99817 21.1596 9.19062 20.995C9.5625 20.7188 17 14.2375 17 8.415C16.9776 6.17542 16.0722 4.03519 14.4806 2.45947C12.8889 0.883744 10.7397 -0.000111977 8.5 1.06406e-08ZM8.5 19.5C6.72563 17.8106 2 12.3781 2 8.415C2 6.72425 2.30446 5.10274 3.5 3.90719C4.69554 2.71165 6.80925 1.5 8.5 1.5C10.1908 1.5 11.8123 2.71165 13.0078 3.90719C14.2034 5.10274 15 6.72425 15 8.415C15 12.3463 10.2744 17.8106 8.5 19.5Z"
                                fill="#6F64A7"
                              />
                              <path
                                d="M8.5 4.25C7.7645 4.25 7.04552 4.4681 6.43397 4.87672C5.82243 5.28534 5.34579 5.86613 5.06432 6.54565C4.78286 7.22516 4.70922 7.97288 4.85271 8.69424C4.9962 9.41561 5.35037 10.0782 5.87045 10.5983C6.39053 11.1184 7.05314 11.4726 7.77451 11.616C8.49588 11.7595 9.24359 11.6859 9.92311 11.4044C10.6026 11.123 11.1834 10.6463 11.592 10.0348C12.0007 9.42323 12.2188 8.70425 12.2188 7.96875C12.2188 6.98248 11.827 6.0366 11.1296 5.3392C10.4322 4.6418 9.48628 4.25 8.5 4.25ZM8.5 10.0348C8.18479 10.0348 7.87665 9.46903 7.61456 9.29391C7.35247 9.11878 7.1482 8.86987 7.02757 8.57865C6.90694 8.28743 6.87538 7.96698 6.93688 7.65782C6.99837 7.34867 6.43397 7.08331 7.37305 6.8418C7.59594 6.61891 7.46535 6.55781 7.77451 6.49632C8.08367 6.43482 8.81868 6.37569 9.1099 6.49632C9.40112 6.61694 9.65003 6.82122 9.82516 7.08331C10.0003 7.3454 10.0938 7.65354 10.0938 7.96875C10.0938 8.39144 9.92584 8.79682 9.62695 9.0957C9.32807 9.39459 8.92269 10.0348 8.5 10.0348Z"
                                fill="#6F64A7"
                              />
                            </svg>
                          </span>
                        </div>
                        <div class="start-location-next-location__location-box" *ngIf="nextLocationPatient">
                          <!-- *ngIf="endLocationPatient" -->
                          <span>Next Location :</span> {{ nextLocationPatient }}
                          <span class="location-icon-box" pTooltip="{{ nextLocationAddress }}" tooltipStyleClass="large-tooltip-outer">
                            <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M8.5 1.06406e-08C6.26031 -0.000111977 4.11108 0.883744 2.51945 2.45947C0.927807 4.03519 0.0223969 6.17542 0 8.415C0 14.2375 7.49063 20.7188 7.80938 20.995C8.00183 21.1596 8.24675 21.2501 8.5 21.2501C8.75325 21.2501 8.99817 21.1596 9.19062 20.995C9.5625 20.7188 17 14.2375 17 8.415C16.9776 6.17542 16.0722 4.03519 14.4806 2.45947C12.8889 0.883744 10.7397 -0.000111977 8.5 1.06406e-08ZM8.5 19.5C6.72563 17.8106 2 12.3781 2 8.415C2 6.72425 2.30446 5.10274 3.5 3.90719C4.69554 2.71165 6.80925 1.5 8.5 1.5C10.1908 1.5 11.8123 2.71165 13.0078 3.90719C14.2034 5.10274 15 6.72425 15 8.415C15 12.3463 10.2744 17.8106 8.5 19.5Z"
                                fill="#6F64A7"
                              />
                              <path
                                d="M8.5 4.25C7.7645 4.25 7.04552 4.4681 6.43397 4.87672C5.82243 5.28534 5.34579 5.86613 5.06432 6.54565C4.78286 7.22516 4.70922 7.97288 4.85271 8.69424C4.9962 9.41561 5.35037 10.0782 5.87045 10.5983C6.39053 11.1184 7.05314 11.4726 7.77451 11.616C8.49588 11.7595 9.24359 11.6859 9.92311 11.4044C10.6026 11.123 11.1834 10.6463 11.592 10.0348C12.0007 9.42323 12.2188 8.70425 12.2188 7.96875C12.2188 6.98248 11.827 6.0366 11.1296 5.3392C10.4322 4.6418 9.48628 4.25 8.5 4.25ZM8.5 10.0348C8.18479 10.0348 7.87665 9.46903 7.61456 9.29391C7.35247 9.11878 7.1482 8.86987 7.02757 8.57865C6.90694 8.28743 6.87538 7.96698 6.93688 7.65782C6.99837 7.34867 6.43397 7.08331 7.37305 6.8418C7.59594 6.61891 7.46535 6.55781 7.77451 6.49632C8.08367 6.43482 8.81868 6.37569 9.1099 6.49632C9.40112 6.61694 9.65003 6.82122 9.82516 7.08331C10.0003 7.3454 10.0938 7.65354 10.0938 7.96875C10.0938 8.39144 9.92584 8.79682 9.62695 9.0957C9.32807 9.39459 8.92269 10.0348 8.5 10.0348Z"
                                fill="#6F64A7"
                              />
                            </svg>
                          </span>
                        </div>
                      </div>

                      <div class="appointment-timeslot-selected">
                        <span class="appointment-timeslot">
                          <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M0 15.5C0 11.3891 1.63303 7.44666 4.53984 4.53984C7.44666 1.63303 11.3891 0 15.5 0C19.6109 0 23.5533 1.63303 26.4602 4.53984C29.367 7.44666 31 11.3891 31 15.5C31 19.6109 29.367 23.5533 26.4602 26.4602C23.5533 29.367 19.6109 31 15.5 31C11.3891 31 7.44666 29.367 4.53984 26.4602C1.63303 23.5533 0 19.6109 0 15.5H0ZM14.6155 22.134L23.5393 10.9781L21.9273 9.68853L14.3179 19.1973L8.928 14.7064L7.60533 16.2936L14.6155 22.1361V22.134Z"
                              fill="#505050"
                            />
                          </svg>

                          Appointment timeslot selected for
                          <strong style="text-transform: capitalize"
                            >{{ salesOrder?.patientInfo?.crmPatientLastName }}, {{ salesOrder?.patientInfo?.crmPatientFirstName }}</strong
                          >
                          at <strong>{{ selectedStartDate | date : 'hh:mm a' | lowercase }} ({{ patientTimezone | timezone }})</strong> for
                          <strong>{{ selectedApptDuration?.name }}</strong
                          >.
                        </span>

                        <div class="appointment-duration">
                          <svg width="35" height="30" viewBox="0 0 35 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M25.3716 3C24.9374 3.0175 24.5158 3.09655 24.1633 3.16896L24.4025 4.23098C24.7549 4.15556 25.1199 4.10788 25.4282 4.08616L25.3716 3ZM26.6239 3.07241L26.4351 4.14047C26.7435 4.20262 27.0518 4.28046 27.3224 4.43615L27.8699 3.48274C27.486 3.28663 27.0581 3.11043 26.6239 3.07241ZM23.0054 3.4767C22.6216 3.62032 22.2377 3.74885 21.9104 3.87496L22.3573 4.87061C22.7034 4.72941 23.0684 4.60631 23.3767 4.50252L23.0054 3.4767ZM28.902 4.28529L28.0398 4.9913C28.2664 5.23991 28.4426 5.54644 28.581 5.79385L29.5942 5.30508C29.3802 4.90983 29.1914 4.61054 28.902 4.28529ZM20.8595 4.3396C20.4756 4.52726 20.161 4.69441 19.8212 4.85854L20.375 5.81195C20.7022 5.63092 21.0609 5.45593 21.3504 5.31714L20.8595 4.3396ZM18.8269 5.41973C18.4934 5.60679 18.1661 5.79385 17.8452 5.99901L18.4619 6.90415C18.7702 6.71105 19.0912 6.53002 19.4058 6.349L18.8269 5.41973ZM29.9844 6.49985C29.6131 6.56019 29.2355 6.60243 28.8642 6.64467C28.8894 6.94639 28.8705 7.27223 28.8076 7.52567L29.9088 7.77308C29.9718 7.33861 30.0284 6.89208 29.9844 6.49985ZM16.8886 6.60243C16.574 6.8076 16.2656 7.0188 15.951 7.22396L16.6055 8.11099C16.9075 7.89979 17.2159 7.70066 17.5242 7.4955L16.8886 6.60243ZM15.0259 7.87566C14.7113 8.09289 14.384 8.33426 14.1134 8.53339L14.7994 9.39628C15.1455 9.15491 15.3846 8.97389 15.6993 8.75062L15.0259 7.87566ZM28.43 8.3584C28.2412 8.63597 28.021 8.91354 27.8007 9.12474L28.6251 9.87902C28.8957 9.57128 29.1852 9.2575 29.3865 8.94372L28.43 8.3584ZM13.2135 9.20922C12.9052 9.43852 12.5968 9.67386 12.3262 9.89109L13.0436 10.7298C13.3394 10.4945 13.6415 10.2531 13.9183 10.06L13.2135 9.20922ZM27.0204 9.81868C26.7309 10.0419 26.4288 10.2592 26.1519 10.4402L26.8001 11.3333C27.1336 11.116 27.4609 10.8807 27.7441 10.6635L27.0204 9.81868ZM11.4515 10.5971C11.1557 10.8264 10.8725 11.0678 10.5831 11.3031L11.3193 12.1298C11.6025 11.8945 11.8857 11.6591 12.1752 11.4298L11.4515 10.5971ZM25.2269 11.0195C24.9059 11.2005 24.5724 11.3876 24.2703 11.5445L24.8115 12.5039C25.1513 12.3048 25.5352 12.1298 25.8184 11.9488L25.2269 11.0195ZM9.72092 12.0212C9.43773 12.2625 9.16084 12.5039 8.87766 12.7513L9.63911 13.5599C9.916 13.3185 10.1992 13.0772 10.4761 12.8358L9.72092 12.0212ZM23.2823 12.0453C22.9488 12.2022 22.6153 12.3651 22.2817 12.522L22.7663 13.4996C23.1565 13.3185 23.4459 13.1677 23.7983 13.0108L23.2823 12.0453ZM21.2686 12.9746C20.9225 13.1254 20.5889 13.2703 20.2365 13.409L20.6959 14.4047C21.042 14.2599 21.3881 14.109 21.7342 13.9582L21.2686 12.9746ZM8.04698 13.4996C7.72604 13.7711 7.50264 13.9823 7.21001 14.2538L8.00922 15.0383C8.30499 14.7667 8.54413 14.5314 8.82102 14.3021L8.04698 13.4996ZM19.2045 13.8495C18.8583 13.9883 18.5122 14.1332 18.1661 14.2719L18.6066 15.2797C18.959 15.1409 19.3052 14.996 19.6513 14.8512L19.2045 13.8495ZM17.1215 14.6943C16.7754 14.8392 16.4293 14.984 16.0768 15.1167L16.5174 16.1244C16.8635 15.9857 17.2159 15.8408 17.562 15.7021L17.1215 14.6943ZM15.0322 15.5391C14.6735 15.696 14.2959 15.8408 13.9876 15.9676L14.4344 16.9692C14.8057 16.8184 15.1581 16.6736 15.4727 16.5408L15.0322 15.5391ZM12.9429 16.396C12.6031 16.5468 12.2067 16.7158 11.9046 16.8486L12.3703 17.8382C12.7416 17.6813 13.0688 17.5244 13.396 17.3916L12.9429 16.396ZM10.8662 17.3011C10.5138 17.464 10.1488 17.633 9.83419 17.7839L10.3439 18.7554C10.6837 18.5864 11.0362 18.4295 11.3445 18.2847L10.8662 17.3011ZM8.81473 18.2847C8.4812 18.4597 8.14767 18.6407 7.80785 18.8278L8.37422 19.7691C8.69516 19.5881 9.0224 19.4191 9.34963 19.2502L8.81473 18.2847ZM6.81985 19.4131C6.46681 19.6062 6.12573 19.8657 5.83185 20.0527L6.51778 20.9217C6.83055 20.7044 7.16722 20.4812 7.43656 20.3243L6.81985 19.4131ZM4.93824 20.7768C4.63618 21.0423 4.33852 21.3501 4.10757 21.6096L4.96971 22.3156C5.21199 22.032 5.4228 21.8208 5.70599 21.5794L4.93824 20.7768ZM18.6444 20.8553L18.7451 21.9354C19.0723 21.8811 19.3995 21.9173 19.7268 21.9656L19.9219 20.8975C19.5065 20.8372 19.066 20.7949 18.6444 20.8553ZM16.3034 21.4587L16.7313 22.4664C17.0586 22.3276 17.3984 22.219 17.7445 22.1164C17.6249 21.7725 17.5368 21.4225 17.4424 21.0725C17.046 21.1811 16.6495 21.326 16.3034 21.4587ZM21.1805 21.4044L20.5386 22.2975C20.8029 22.4845 21.0609 22.6837 21.2686 22.9311L22.1244 22.219C21.8035 21.9052 21.558 21.6096 21.1805 21.4044ZM15.2336 21.9475C14.8875 22.1164 14.5539 22.3095 14.2204 22.4966L14.7931 23.4319C15.1203 23.2629 15.4413 23.0638 15.7622 22.9009L15.2336 21.9475ZM3.41597 22.6112C3.22592 23.0035 3.07174 23.4259 3 23.8L4.11386 23.987C4.18182 23.6431 4.27937 23.3957 4.42222 23.1C4.07673 22.9552 3.74698 22.7802 3.41597 22.6112ZM13.2387 23.0819C12.9178 23.281 12.6031 23.4802 12.2885 23.6853L12.9178 24.5905C13.2324 24.3913 13.5408 24.1862 13.8554 23.987L13.2387 23.0819ZM22.8481 23.1543L21.8979 23.7457C22.0992 24.0353 22.2943 24.337 22.4768 24.6448L23.4585 24.1017C23.2383 23.7638 23.0809 23.4621 22.8481 23.1543ZM11.3508 24.3008C11.0362 24.5 10.7215 24.6931 10.4131 24.9043L11.0424 25.8094C11.3445 25.5982 11.6655 25.3991 11.9864 25.1939L11.3508 24.3008ZM4.12645 24.8741C3.76208 24.9465 3.39457 25.0068 3.02832 25.0732C3.09439 25.4956 3.27123 25.9059 3.43107 26.2318L4.45368 25.7611C4.31712 25.4594 4.18749 25.1456 4.12645 24.8741ZM24.0186 25.043L23.0369 25.5861C23.232 25.912 23.4585 26.262 23.641 26.5395L24.5913 25.9542C24.3773 25.6344 24.1948 25.3327 24.0186 25.043ZM9.48178 25.4956C9.16714 25.6827 8.85878 25.8637 8.53154 26.0387L9.09162 26.9861C9.42515 26.799 9.75868 26.6119 10.0796 26.4128L9.48178 25.4956ZM4.99488 26.4792L4.22084 27.2757C4.57073 27.5955 5.00243 27.8067 5.47315 27.9033L5.72487 26.8473C5.44546 26.793 5.1843 26.6602 4.99488 26.4792ZM7.57501 26.4973C7.25973 26.6361 6.93249 26.7447 6.5933 26.8111L6.85131 27.8731C7.25532 27.7946 7.63542 27.6498 8.01552 27.499L7.57501 26.4973ZM25.2143 26.7869L24.3395 27.4688C24.6101 27.7886 24.9437 28.0964 25.2332 28.3136L25.9317 27.4567C25.6548 27.2516 25.4156 27.0042 25.2143 26.7869ZM26.7309 27.8429L26.4477 28.8989C26.9448 28.9955 27.3161 29.0256 27.7818 28.9774L27.6434 27.8972C27.335 27.9455 27.0329 27.9153 26.7309 27.8429Z"
                              fill="#262626"
                            />
                            <path
                              d="M5.99973 3.59521C5.56303 3.59521 5.13614 3.7179 4.77304 3.94774C4.40993 4.17759 4.12693 4.50428 3.95981 4.8865C3.7927 5.26872 3.74897 5.68931 3.83417 6.09507C3.91936 6.50084 4.12965 6.87356 4.43844 7.1661C4.74724 7.45864 5.14066 7.65786 5.56897 7.73857C5.99728 7.81928 6.44123 7.77786 6.84469 7.61954C7.24814 7.46122 7.59298 7.19311 7.8356 6.84912C8.07822 6.50513 8.20771 6.1007 8.20771 5.68699C8.20704 5.13241 7.9742 4.60073 7.56027 4.20858C7.14634 3.81643 6.58512 3.59585 5.99973 3.59521ZM5.99973 6.73288C5.78138 6.73288 5.56793 6.67154 5.38638 6.55661C5.20483 6.44169 5.06333 6.27834 4.97977 6.08723C4.89621 5.89612 4.87435 5.68583 4.91695 5.48295C4.95954 5.28006 5.06469 5.09371 5.21909 4.94744C5.37348 4.80117 5.57019 4.70155 5.78435 4.6612C5.9985 4.62084 6.22048 4.64156 6.42221 4.72072C6.62393 4.79988 6.79635 4.93393 6.91766 5.10593C7.03897 5.27792 7.10372 5.48013 7.10372 5.68699C7.10338 5.96428 6.98696 6.23012 6.77999 6.42619C6.57303 6.62226 6.29242 6.73256 5.99973 6.73288Z"
                              fill="#404040"
                            />
                            <path
                              d="M10.2426 1.66444C9.19353 0.670857 7.79318 0.0806308 6.3118 0.00767144C4.83042 -0.0652879 3.37301 0.384192 2.22087 1.26936C1.06873 2.15453 0.303529 3.41264 0.0729496 4.80087C-0.15763 6.1891 0.16276 7.60904 0.972283 8.78664L5.14355 14.8532C5.23637 14.9882 5.36329 15.0991 5.5128 15.1759C5.66231 15.2527 5.82968 15.2929 5.99974 15.2929C6.1698 15.2929 6.33718 15.2527 6.48669 15.1759C6.6362 15.0991 6.76312 14.9882 6.85594 14.8532L11.0273 8.78664C11.7785 7.69424 12.1104 6.39044 11.9676 5.09375C11.8247 3.79707 11.2157 2.58632 10.2426 1.66444ZM10.1023 8.21575L5.99976 14.1822L1.89715 8.21575C0.641361 6.3894 0.910701 3.94529 2.53757 2.40398C2.99223 1.97324 3.53199 1.63156 4.12603 1.39844C4.72008 1.16533 5.35677 1.04534 5.99976 1.04534C6.64275 1.04534 7.27945 1.16533 7.87349 1.39844C8.46753 1.63156 9.00729 1.97324 9.46195 2.40398C11.0888 3.94529 11.3581 6.3894 10.1023 8.21575Z"
                              fill="#404040"
                            />
                            <path
                              d="M28.9997 17.5952C28.563 17.5952 28.1361 17.7179 27.773 17.9477C27.4099 18.1776 27.1269 18.5043 26.9598 18.8865C26.7927 19.2687 26.749 19.6893 26.8342 20.0951C26.9194 20.5008 27.1297 20.8736 27.4384 21.1661C27.7472 21.4586 28.1407 21.6579 28.569 21.7386C28.9973 21.8193 29.4412 21.7779 29.8447 21.6195C30.2481 21.4612 30.593 21.1931 30.8356 20.8491C31.0782 20.5051 31.2077 20.1007 31.2077 19.687C31.207 19.1324 30.9742 18.6007 30.5603 18.2086C30.1463 17.8164 29.5851 17.5958 28.9997 17.5952ZM28.9997 20.7329C28.7814 20.7329 28.5679 20.6715 28.3864 20.5566C28.2048 20.4417 28.0633 20.2783 27.9798 20.0872C27.8962 19.8961 27.8743 19.6858 27.9169 19.4829C27.9595 19.2801 28.0647 19.0937 28.2191 18.9474C28.3735 18.8012 28.5702 18.7016 28.7843 18.6612C28.9985 18.6208 29.2205 18.6416 29.4222 18.7207C29.6239 18.7999 29.7964 18.9339 29.9177 19.1059C30.039 19.2779 30.1037 19.4801 30.1037 19.687C30.1034 19.9643 29.987 20.2301 29.78 20.4262C29.573 20.6223 29.2924 20.7326 28.9997 20.7329Z"
                              fill="#404040"
                            />
                            <path
                              d="M33.2426 15.6644C32.1935 14.6709 30.7932 14.0806 29.3118 14.0077C27.8304 13.9347 26.373 14.3842 25.2209 15.2694C24.0687 16.1545 23.3035 17.4126 23.0729 18.8009C22.8424 20.1891 23.1628 21.609 23.9723 22.7866L28.1435 28.8532C28.2364 28.9882 28.3633 29.0991 28.5128 29.1759C28.6623 29.2527 28.8297 29.2929 28.9997 29.2929C29.1698 29.2929 29.3372 29.2527 29.4867 29.1759C29.6362 29.0991 29.7631 28.9882 29.8559 28.8532L34.0273 22.7866C34.7785 21.6942 35.1104 20.3904 34.9676 19.0938C34.8247 17.7971 34.2157 16.5863 33.2426 15.6644ZM33.1023 22.2157L28.9998 28.1822L24.8972 22.2157C23.6414 20.3894 23.9107 17.9453 25.5376 16.404C25.9922 15.9732 26.532 15.6316 27.126 15.3984C27.7201 15.1653 28.3568 15.0453 28.9998 15.0453C29.6428 15.0453 30.2794 15.1653 30.8735 15.3984C31.4675 15.6316 32.0073 15.9732 32.4619 16.404C34.0888 17.9453 34.3581 20.3894 33.1023 22.2157Z"
                              fill="#404040"
                            />
                          </svg>
                          <span class="appointment-duration__miles-away-box" *ngFor="let item of displayData">
                            <strong class="miles-away" [ngStyle]="{ color: item.color }"
                              >{{ item.miles }}  miles away <i class="info-new ml-10" style="margin: 0px 0 -4px 5px" pTooltip="{{ item.DiaplayText }}"></i
                            ></strong>
                            |
                            <strong class="eta-time">{{ item.googleTime }} ETA</strong>
                            <span *ngIf="item.isStartingLocation"> from location of </span>
                            <span *ngIf="!item.isStartingLocation"> to location of </span>
                            <strong style="text-transform: capitalize">"{{ item.patientName }}"</strong>
                          </span>
                         
                        </div>

                        <div class="end-location">
                          <span>End Location :</span> &nbsp;{{ endLocationPatient }}
                          <span class="location-icon-box" pTooltip="{{ endLocationAddress }}">
                            <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M8.5 1.06406e-08C6.26031 -0.000111977 4.11108 0.883744 2.51945 2.45947C0.927807 4.03519 0.0223969 6.17542 0 8.415C0 14.2375 7.49063 20.7188 7.80938 20.995C8.00183 21.1596 8.24675 21.2501 8.5 21.2501C8.75325 21.2501 8.99817 21.1596 9.19062 20.995C9.5625 20.7188 17 14.2375 17 8.415C16.9776 6.17542 16.0722 4.03519 14.4806 2.45947C12.8889 0.883744 10.7397 -0.000111977 8.5 1.06406e-08ZM8.5 19.5C6.72563 17.8106 2 12.3781 2 8.415C2 6.72425 2.30446 5.10274 3.5 3.90719C4.69554 2.71165 6.80925 1.5 8.5 1.5C10.1908 1.5 11.8123 2.71165 13.0078 3.90719C14.2034 5.10274 15 6.72425 15 8.415C15 12.3463 10.2744 17.8106 8.5 19.5Z"
                                fill="#6F64A7"
                              />
                              <path
                                d="M8.5 4.25C7.7645 4.25 7.04552 4.4681 6.43397 4.87672C5.82243 5.28534 5.34579 5.86613 5.06432 6.54565C4.78286 7.22516 4.70922 7.97288 4.85271 8.69424C4.9962 9.41561 5.35037 10.0782 5.87045 10.5983C6.39053 11.1184 7.05314 11.4726 7.77451 11.616C8.49588 11.7595 9.24359 11.6859 9.92311 11.4044C10.6026 11.123 11.1834 10.6463 11.592 10.0348C12.0007 9.42323 12.2188 8.70425 12.2188 7.96875C12.2188 6.98248 11.827 6.0366 11.1296 5.3392C10.4322 4.6418 9.48628 4.25 8.5 4.25ZM8.5 10.0348C8.18479 10.0348 7.87665 9.46903 7.61456 9.29391C7.35247 9.11878 7.1482 8.86987 7.02757 8.57865C6.90694 8.28743 6.87538 7.96698 6.93688 7.65782C6.99837 7.34867 6.43397 7.08331 7.37305 6.8418C7.59594 6.61891 7.46535 6.55781 7.77451 6.49632C8.08367 6.43482 8.81868 6.37569 9.1099 6.49632C9.40112 6.61694 9.65003 6.82122 9.82516 7.08331C10.0003 7.3454 10.0938 7.65354 10.0938 7.96875C10.0938 8.39144 9.92584 8.79682 9.62695 9.0957C9.32807 9.39459 8.92269 10.0348 8.5 10.0348Z"
                                fill="#6F64A7"
                              />
                            </svg>
                          </span>
                        </div>



                      </div>
                    </div>

                    <div class="googlemap-outer" [ngClass]="isShowLocationInfo ? 'googlemap-half' : ''">
                      <!-- <google-map class="google-map" height="600px" width="100%" [center]="center" [options]="options" [zoom]="zoom" (mapMousemove)="move($event)">
                        <map-marker
                          #somemarker="mapMarker"
                          *ngFor="let marker of markers"
                          [position]="marker.position"
                          [icon]="marker.icon"
                          [label]="marker.label"
                          [title]="marker.title"
                          [options]="marker.options"
                          (mapClick)="openInfoWindow(somemarker, marker.info)"
                        >
                        </map-marker>
                        <map-info-window [options]="infoWindowOptions">
                          <div [innerHtml]="infoContent"></div>
                        </map-info-window>
                        <map-circle [center]="circleCenter" [radius]="radius" [options]="circleOption"> </map-circle>
                        <map-directions-renderer *ngIf="directionsResults | async as directionsResults" [directions]="directionsResults" [options]="rendererOptions">
                        </map-directions-renderer>
                      </google-map> -->
                      

                      <!-- Legacy Google Maps block removed in favor of NextBillion. If you need to rollback, re-add the <google-map> block here. -->
                       <!-- <map-marker
                          #somemarker="mapMarker"
                          *ngFor="let marker of markers"
                          [position]="marker.position"
                          [icon]="marker.icon"
                          [label]="marker.label"
                          [title]="marker.title"
                          [options]="marker.options"
                          (mapClick)="openInfoWindow(somemarker, marker.info)"
                        >
                        </map-marker>
                        <map-info-window [options]="infoWindowOptions">
                          <div [innerHtml]="infoContent"></div>
                        </map-info-window>
                        <map-circle [center]="circleCenter" [radius]="radius" [options]="circleOption"> </map-circle>
                        <map-directions-renderer *ngIf="directionsResults | async as directionsResults" [directions]="directionsResults" [options]="rendererOptions">
                        </map-directions-renderer>
                      </google-map> -->
                    

                      <app-map [points]="points" (navigationData)="onNavigationData($event)"></app-map>

                      
                      </div>
                  </div>
                </div>
                <!-- if time slow not showing then show below msg-->
                <div class="no-slots-available-selected-week" *ngIf="isAppointmentTypeAvailable && !islotAvailable">
                  <span *ngIf="isLicenseCheckEnabled"> There is no therapist available having licensed in the state of the Patient’s address. </span>
                  <span *ngIf="!isLicenseCheckEnabled">
                    There are no time-slots available/set up on the selected day/week, please select a different day or location.
                  </span>
                </div>

                <div class="no-slots-available-selected-week" *ngIf="!isAppointmentTypeAvailable">
                  <span *ngIf="!isAppointmentTypeAvailable && isMedicareinsurance"> There is Insurance policy restriction to the facility. </span>
                  <span *ngIf="isLicenseCheckEnabled && isInsuranceStateNotFound">
                    There is no therapist available having licensed in the state of the Patient’s address.
                  </span>
                  <span *ngIf="!isLicenseCheckEnabled">
                    There are no time-slots available/set up on the selected facility, please select a different day or location.
                  </span>
                  <span *ngIf="isLicenseCheckEnabled && !islotAvailable">
                    There are no time-slots available/set up on the selected facility, please select a different day or location.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="configured-text" *ngIf="!isDeliveryAddressAvailable">
          Delivery address not configured in the system. Please add the delivery address or continue with the billing address.
        </div>
        <!-- footer part -->
      </p-scrollPanel>
      <!-- <ng-template *ngIf="selectedStartDate"></ng-template> -->
      <div class="book-appt-outer-block__footer">
        <div class="book-appt-outer-block__footer__left">
          <div class="book-appt-outer-block__footer__column">
            <strong>
              {{ scheduleActionePopUp }} <br />
              Appointment Details
            </strong>
          </div>

          <div class="book-appt-outer-block__footer__column" *ngIf="selectedStartDate">
            <strong>Date</strong>
            <span>{{ selectedStartDate | date : appDateFormat.dateFormat }}</span>
          </div>

          <div class="book-appt-outer-block__footer__column" *ngIf="selectedStartDate">
            <strong>Time</strong>
            <!-- selectedtherapistBasedTimeZone -->
            <span>{{ selectedStartDate | date : 'hh:mm a' | lowercase }} ({{ patientTimezone | timezone }})</span>
          </div>

          <div class="book-appt-outer-block__footer__column" *ngIf="selectedStartDate && false">
            <strong>Time Zone</strong>
            <!--<span>{{selectedTimeZone?.name ||appDateFormat.timeZone}}</span>-->
          </div>
          <div class="book-appt-outer-block__footer__column" *ngIf="selectedStartDate">
            <strong>Location</strong>
            <span
              class="location"
              pTooltip="{{
                selectedAppointmentTypePopUp == 'Telehealth'
                  ? selectedFacilityLocal.crmFacilityName
                  : selectedAppointmentTypePopUp == 'Home Visit'
                  ? 'Road/Home Visit'
                  : selectedFacilityLocal.crmFacilityName
              }}"
            >
              {{
                selectedAppointmentTypePopUp == 'Telehealth'
                  ? selectedFacilityLocal.crmFacilityName
                  : selectedAppointmentTypePopUp ==
                    'Home
              Visit'
                  ? 'Road/Home Visit'
                  : selectedFacilityLocal.crmFacilityName
              }}
            </span>
          </div>
          <div class="book-appt-outer-block__footer__column" *ngIf="selectedRemoteAppointmentType != 'SelfGuided'">
            <strong>Duration</strong>
            <span>{{ selectedApptDuration?.name }}</span>
          </div>
          <div class="book-appt-outer-block__footer__column" *ngIf="selectedRemoteAppointmentType == 'SelfGuided'">
            <strong>Duration</strong>
            <span>{{ selectedselfGuidedApptDuration?.name }}</span>
          </div>
          <div class="book-appt-outer-block__footer__column" *ngIf="selectedStartDate">
            <strong>Therapist</strong>
            <span class="therapist" pTooltip="{{ selectedTherapistName }}">{{ selectedTherapistName }}</span>
          </div>
        </div>
        <div class="book-appt-outer-block__footer__right">
          <!--<button class="btn btn--confirm btn-next" (click)="onConfirm()"><i class="btn-check-arrow"></i> Confirm {{selectedAppointmentTypePopUp=='Telehealth'?'Remote Setup':selectedAppointmentTypePopUp=='Home Visit'?'Road/Home Visit':selectedAppointmentTypePopUp}}</button>-->
          <button class="btn btn--confirm btn-next" (click)="onConfirm()"><i class="btn-check-arrow"></i>Confirm Selection</button>
        </div>
      </div>
    </div>

    <p-dialog [(visible)]="displayoptOutNotification" styleClass="display-close-icon" [modal]="true" appendTo="body" [baseZIndex]="9999999">
      <div class="search-box-outer delivery">
        <h2 class="filter-title" style="padding: 0">Confirmation</h2>
        <div>
          <p>You are trying to reschedule the appointment at the same time.</p>
          <p>Do you want to send a notification to the patient as per their 'Preferred Patient Communication' selection?</p>
        </div>
        <!-- <div class="btn-block app-not-scheduled-appointments-btn">
          <button #yesButton class="btn btn--primary" style="margin-left:100px;">Yes (Send notification)</button>
          <a #noButton class="btn btn--secondary clear-filter" href="javascript:void(0)" >
            No (Do not send notification)
          </a> -->
        <div class="btn-block app-not-scheduled-appointments-btn" style="justify-content: flex-end">
          <a #noButton class="btn btn--secondary clear-filter" href="javascript:void(0)">No (Do not send notification)</a>
          <button #yesButton class="btn btn--primary">Yes (Send notification)</button>
        </div>
      </div>
    </p-dialog>

    <!-- Confirm Page -->
    <div class="confirm-page-outer" [ngClass]="confirmDetialsPage ? 'active' : 'inactive'">
      <app-confirm-appointment
        [appointmentConfirmationInfo]="appointmentConfirmationInfo"
        [salesOrder]="salesOrder"
        [crmPatientPhoneNumber]="salesOrder?.patientInfo?.crmPatientPhoneNo"
        [crmPatientEmailAddress]="salesOrder?.patientInfo?.crmPatientEmailAddress"
        [crmSalesorderDeliveryNote]="salesOrder?.crmSalesorderDeliveryNote"
        [crmSalesorderOrderNote]="salesOrder?.crmSalesorderOrderNote"
        [crmPatientMobileNumber]="salesOrder?.patientInfo?.crmPatientMobileNumber"
        [isBrightreeSystemAppUpdate]="isBrightreeSystemAppUpdate"
        [twillioDeviceConnectionObject]="twillioDeviceConnectionObject"
        [crmPatientTimezone]="patientTimezone"
        [crmFacilityTimeZone]="selectedtherapistBasedTimeZone" (appintmentBooked)="appointmentBookedHandler()"
        [isPODStatusBrightreeSystemAppUpdate]="isPODStatusBrightreeSystemAppUpdate"
        [isAppendOrderNoteBrightreeSystemAppUpdate]="isAppendOrderNoteBrightreeSystemAppUpdate"
        [roadHomeVisitHistory]="roadHomeVisitRequest"
        [optOutRescheduleReminder]="optOutRescheduleReminder"
      >
      </app-confirm-appointment>
    </div>
  </div>
</div>

<!-- Schedule Call Back popup -->
<p-dialog [(visible)]="displayScheduleCallBack" styleClass="display-close-icon" [modal]="true" appendTo="body">
  <div class="popup-content-outer">
    <h2>Schedule Call Back</h2>

    <div class="schedulecall">
      <div class="schedulecall__info" *ngIf="isSchedulecallBack && !hasCallbackDatePassed">
        <p class="schedule-content">
          Schedule call back for <strong> “{{ salesOrder?.patientInfo?.crmPatientLastName }}, {{ salesOrder?.patientInfo?.crmPatientFirstName }}” </strong> has already
          been booked.
        </p>
        <p><strong>Date :</strong> {{ previousCallbackDate | date : appDateFormat.dateFormat }}</p>
        <p><strong>Time :</strong> {{ previousCallbackDate | date : 'hh:mm a' | lowercase }} | {{ _schTimezone | timezone }}</p>
      </div>

      <form class="form form--schedulecall" [formGroup]="formCallAppointment" autocomplete="off" *ngIf="formCallAppointment">
        <!-- <h3 *ngIf="isSchedulecallBack">Reschedule Call Back</h3> -->
        <div class="col">
          <div class="form__group">
            <label class="form__label">Date</label>
            <p-datepicker
              class="form__calendars date-pikar"
              [showIcon]="true"
              [minDate]="minimumDate"
              [(ngModel)]="calldate"
              formControlName="calldate"
              appendTo="body"
            ></p-datepicker>
            <div *ngIf="formAppointmentCallSubmitted && fCallAppointment.calldate.errors" class="invalid-feedback-error">
              <span *ngIf="fCallAppointment.calldate.errors.required || fCallAppointment.calldate.errors.whitespace">
                {{ validationMessages.calldate.required }}
              </span>
            </div>
          </div>
          <div class="form__group">
            <label class="form__label">Time</label>
            <ngx-timepicker-field [(ngModel)]="customStartTime" [format]="12" minutesGap="15" [controlOnly]="true" [ngModelOptions]="{ standalone: true }">
            </ngx-timepicker-field>
            <div *ngIf="formAppointmentCallSubmitted && !isValid" class="invalid-feedback-error">
              <span> {{ validationMessages.calltime.required }}</span>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form__group full-width">
            <label class="form__label"> Note </label>
            <textarea class="form__textarea" pInputTextarea [(ngModel)]="callnote" formControlName="callnote" maxlength="200"></textarea>
            <div *ngIf="formAppointmentCallSubmitted && fCallAppointment.callnote.errors" class="invalid-feedback-error">
              <span *ngIf="fCallAppointment.callnote.errors.required || fCallAppointment.callnote.errors.whitespace">
                {{ validationMessages.callnote.required }}
              </span>
            </div>
          </div>
        </div>
        <div class="call-popup-appointment">
          <button class="btn btn--primary" (click)="ScheduleFutureCallBackAppointemnt()">Submit</button>
          <a href="javascript:void(0)" (click)="CancelScheduleFutureCallBackAppointemnt()" class="btn btn--secondary">Cancel</a>
        </div>
      </form>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="displayPhoneCallLog" styleClass="display-close-icon" [modal]="true" appendTo="body">
  <div class="popup-content-outer">
    <h2>Call Logs</h2>

    <div class="schedulecall">
      <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
        <div *ngIf="!isAppointment && salesOrder?.calllogs?.length > 0" class="patient-info callLogs-info">
          <div class="patient-info-top">
            <div *ngFor="let callLog of salesOrder.calllogs; let i = index">
              <div [ngClass]="i == 0 ? 'callLogs-block' : 'callLogs-block last'" *ngIf="!callLog?.callSID">
                <span class="details-group" *ngIf="callLog?.schAppointmentCallDateTime">
                  <label class="details-label">Date</label>
                  <span class="details-desc">
                    {{ callLog?.schAppointmentCallDateTime | date : appDateFormat.dateFormat }} at
                    <span class="time">
                      {{ callLog.schAppointmentCallDateTime | date : 'shortTime' | lowercase }}
                    </span>
                  </span>
                </span>
                <span class="details-group" *ngIf="callLog?.schAppointmentCallByPerson">
                  <label class="details-label">Called By</label>
                  <span class="details-desc">{{ callLog?.schAppointmentCallByPerson }}</span>
                </span>
                <span class="details-group note" *ngIf="callLog?.schAppointmentCallNote">
                  <label class="details-label">Notes</label>
                  <span class="details-desc">{{ callLog?.schAppointmentCallNote }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="!isAppointment && salesOrder?.calllogs?.length <= 0" class="patient-info callLogs-info">No Call Logs</div>
        <div *ngIf="isAppointment && appointment.appointmentHistoryInfo?.length > 0" class="patient-info callLogs-info">
          <div class="patient-info-top">
            <div *ngFor="let appHist of appointment.appointmentHistoryInfo; let i = index">
              <div [ngClass]="i == 0 ? 'callLogs-block' : 'callLogs-block last'" *ngIf="appHist.isCall && !appHist?.callSID">
                <span class="details-group" *ngIf="appHist?.dateTimeHistory">
                  <label class="details-label">Date</label>
                  <span class="details-desc">
                    {{ appHist?.dateTimeHistory | date : appDateFormat.dateFormat }} at
                    <span class="time">
                      {{ appHist.dateTimeHistory | date : 'shortTime' | lowercase }}
                    </span>
                  </span>
                </span>
                <span class="details-group" *ngIf="appHist?.schAppointmentCallByPerson">
                  <label class="details-label">Called By</label>
                  <span class="details-desc">{{ appHist?.schAppointmentCallByPerson }}</span>
                </span>
                <span class="details-group note" *ngIf="appHist?.schAppointmentCallNote">
                  <label class="details-label">Notes</label>
                  <span class="details-desc">{{ appHist?.schAppointmentCallNote }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="isAppointment && appointment.appointmentHistoryInfo?.length <= 0" class="patient-info callLogs-info">No Call Logs</div>
      </p-scrollPanel>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="displayVoiceCallLog" styleClass="display-close-icon" [modal]="true" appendTo="body">
  <div class="popup-content-outer">
    <h2>Call Logs</h2>

    <div class="schedulecall">
      <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
        <div *ngIf="!isAppointment && salesOrder?.calllogs?.length > 0" class="patient-info callLogs-info">
          <div class="patient-info-top">
            <div *ngFor="let callLog of salesOrder?.calllogs; let i = index">
              <div [ngClass]="i == 0 ? 'callLogs-block' : 'callLogs-block last'" *ngIf="callLog?.callSID">
                <span class="details-group" *ngIf="callLog?.schAppointmentCallDateTime">
                  <label class="details-label">Date</label>
                  <span class="details-desc">
                    {{ callLog?.schAppointmentCallDateTime | date : appDateFormat.dateFormat }} at
                    <span class="time">
                      {{ callLog.schAppointmentCallDateTime | date : 'shortTime' | lowercase }}
                    </span>
                  </span>
                </span>
                <span class="details-group" *ngIf="callLog?.schAppointmentCallByPerson">
                  <label class="details-label">Called By</label>
                  <span class="details-desc">{{ callLog?.schAppointmentCallByPerson }}</span>
                </span>
                <span class="details-group note" *ngIf="callLog?.schAppointmentCallNote">
                  <label class="details-label">Notes</label>
                  <span class="details-desc">{{ callLog?.schAppointmentCallNote }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="!isAppointment && salesOrder?.calllogs?.length <= 0" class="patient-info callLogs-info">No Call Logs</div>
        <div *ngIf="isAppointment && appointment.appointmentHistoryInfo?.length > 0" class="patient-info callLogs-info">
          <div class="patient-info-top">
            <div *ngFor="let appHist of appointment.appointmentHistoryInfo; let i = index">
              <div [ngClass]="i == 0 ? 'callLogs-block' : 'callLogs-block last'" *ngIf="appHist?.callSID">
                <span class="details-group" *ngIf="appHist?.dateTimeHistory">
                  <label class="details-label">Date</label>
                  <span class="details-desc">
                    {{ appHist?.dateTimeHistory | date : appDateFormat.dateFormat }} at
                    <span class="time">
                      {{ appHist.dateTimeHistory | date : 'shortTime' | lowercase }}
                    </span>
                  </span>
                </span>
                <span class="details-group" *ngIf="appHist?.schAppointmentCallByPerson">
                  <label class="details-label">Called By</label>
                  <span class="details-desc">{{ appHist?.schAppointmentCallByPerson }}</span>
                </span>
                <span class="details-group note" *ngIf="appHist?.schAppointmentCallNote">
                  <label class="details-label">Notes</label>
                  <span class="details-desc">{{ appHist?.schAppointmentCallNote }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="isAppointment && appointment.appointmentHistoryInfo?.length <= 0" class="patient-info callLogs-info">No Call Logs</div>
      </p-scrollPanel>
    </div>
  </div>
</p-dialog>

<!-- Cancel Appointment popup -->
<p-dialog [(visible)]="displayCancelAppointment" styleClass="display-close-icon" [modal]="true" appendTo="body">
  <div class="popup-content-outer cancel-appointment">
    <h2>Cancel Appointment</h2>
    <div class="schedulecall">
      <form class="form" [formGroup]="formCancel" autocomplete="off" *ngIf="formCancel">
        <div class="schedulecall">
          <div class="col">
            <div class="form__group full-width">
              <label class="form__label">Reason</label>
              <p-select
                class="form__dropdown"
                filter="true"
                [options]="cancellationReasonsResponseModel"
                formControlName="reason"
                placeholder="Select Reason"
                optionLabel="salesOrderVoidReason"
              ></p-select>

              <div *ngIf="formCancelSubmitted && fCancel.reason.errors" class="invalid-feedback-error">
                <span *ngIf="fCancel.reason.errors.required || fCancel.reason.errors.whitespace">
                  {{ validationMessages.reason.required }}
                </span>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form__group full-width">
              <label class="form__label">Comment</label>

              <textarea class="form__textarea" pInputTextarea formControlName="reasonComments" maxlength="100"></textarea>
              <div *ngIf="formCancelSubmitted && fCancel.reasonComments.errors" class="invalid-feedback-error">
                <span *ngIf="fCancel.reasonComments.errors.required || fCancel.reasonComments.errors.whitespace">
                  {{ validationMessages.reasonComments.required }}
                </span>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="check receive-reminder wip-state-will-not-update">
              <span class="form__checkbox-outer">
                <p-checkbox
                  name="groupnamecancel"
                  label="If box checked, the WIP State will not be updated in Brightree"
                  [(ngModel)]="isBrightreeSystemAppUpdateVoidCancel"
                  binary="true"
                  (onChange)="onBTSelect($event)"
                  [ngModelOptions]="{ standalone: true }"
                  inputId="IfboxcheckedtheWIPStatewillnotbeupdatedinBrightree4"
                >
                </p-checkbox>
                <label class="form__checkbox-label" for="IfboxcheckedtheWIPStatewillnotbeupdatedinBrightree4"
                  >If box checked, the WIP State will not be updated in Brightree</label
                >
              </span>
            </div>
          </div>
          <div class="appointment-calcel-btn">
            <button class="btn btn--primary" (click)="cancelAppointment()">Submit</button>
            <a href="javascript:void(0)" class="btn btn--secondary" (click)="hideAppointmentpopup()">Cancel</a>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="loader-block" *ngIf="loadingCancel" style="z-index: 99999999 !important">
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="8" fill="#ffffff" animationDuration=".8s"> </p-progressSpinner>
  </div>
</p-dialog>

<div class="loader-block" *ngIf="loadingCancel && startLoading" style="z-index: 99999999 !important">
  <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="8" fill="#ffffff" animationDuration=".8s"> </p-progressSpinner>
</div>

<!-- Void Appointment popup -->
<p-dialog [(visible)]="displayVoidAppointment" styleClass="display-close-icon" [modal]="true" appendTo="body">
  <div class="popup-content-outer cancel-appointment">
    <h2>
      {{ this.isRescheduledRequest ? ' Void Appointment' : 'Void Sales Order' }}
    </h2>
    <div class="schedulecall">
      <form class="form" [formGroup]="formVoidAppointment" autocomplete="off" *ngIf="formVoidAppointment">
        <div class="schedulecall">
          <div class="col">
            <div class="form__group full-width">
              <label class="form__label">Reason</label>
              <p-select
                class="form__dropdown select-box"
                [options]="voidReasonsResponseModel"
                formControlName="voidReason"
                placeholder="Select Reason"
                optionLabel="salesOrderVoidReason"
                filter="true"
              ></p-select>
              <div *ngIf="formVoidAppointmentSubmitted && fVoid.voidReason.errors" class="invalid-feedback-error">
                <span *ngIf="fVoid.voidReason.errors.required || fVoid.voidReason.errors.whitespace">
                  {{ validationMessages.voidReason.required }}
                </span>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form__group full-width">
              <label class="form__label">Comment</label>
              <textarea class="form__textarea" pInputTextarea formControlName="voidReasonComments" maxlength="100"></textarea>
              <div *ngIf="formVoidAppointmentSubmitted && fVoid.voidReasonComments.errors" class="invalid-feedback-error">
                <span *ngIf="fVoid.voidReasonComments.errors.required || fVoid.voidReasonComments.errors.whitespace">
                  {{ validationMessages.voidReasonComments.required }}
                </span>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="check receive-reminder wip-state-will-not-update">
              <span class="form__checkbox-outer">
                <p-checkbox
                  name="groupnamevoid"
                  label="If box checked, the WIP State will not be updated in Brightree"
                  [(ngModel)]="isBrightreeSystemAppUpdateVoidCancel"
                  binary="true"
                  (onChange)="onBTSelect($event)"
                  [ngModelOptions]="{ standalone: true }"
                  inputId="IfboxcheckedtheWIPStatewillnotbeupdatedinBrightree3"
                >
                </p-checkbox>
                <label class="form__checkbox-label" for="IfboxcheckedtheWIPStatewillnotbeupdatedinBrightree3"
                  >If box checked, the WIP State will not be updated in Brightree</label
                >
              </span>
            </div>
          </div>
          <div class="call-popup-appointment">
            <button class="btn btn--primary" (click)="voidAppointment()">Submit</button>
            <a href="javascript:void(0)" class="btn btn--secondary" (click)="cancelVoidAppointment()">Cancel</a>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="loader-block" *ngIf="loadingVoid" style="z-index: 99999999 !important">
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="8" fill="#ffffff" animationDuration=".8s"> </p-progressSpinner>
  </div>
</p-dialog>

<!-- Order Note Popup-->
<p-dialog [(visible)]="displayOrderNote" styleClass="display-close-icon" [modal]="true" appendTo="body" [baseZIndex]="9999999">
  <div class="search-box-outer delivery">
    <h2 class="filter-title" style="padding: 0">Order Note</h2>

    <div class="form__group order-note">
      <textarea class="form__textarea" maxlength="8000" [(ngModel)]="crmSalesorderOrderNote" pInputTextarea> </textarea>
    </div>

    <div class="btn-block app-not-scheduled-appointments-btn">
      <button class="btn btn--primary" (click)="SaveOrderNoteBTClick()">Save</button>
      <a class="btn btn--secondary clear-filter" href="javascript:void(0)" (click)="CancelOrderNoteBTClick()"> Cancel </a>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="displayDeliveryAddress" styleClass="display-close-icon" [modal]="true" appendTo="body">
  <div class="popup-content-outer cancel-appointment">
    <h2>Update Delivery Address</h2>
    <div class="">
      <form class="form" [formGroup]="formDeliveryAddress" autocomplete="off" *ngIf="formDeliveryAddress">
        <div class="schedulecall">
          <div class="col">
            <div class="form__group full-width">
              <label class="form__label">Address Line 1</label>
              <!-- <textarea class="form__textarea" formControlName="deliveryAddressLine1" pInputTextarea></textarea> -->
              <input type="text" class="form__control" formControlName="deliveryAddressLine1" pInputText />
              <div *ngIf="formDeliveryAddressSubmitted && fDeliveryAddress.deliveryAddressLine1.errors" class="invalid-feedback">
                <div *ngIf="fDeliveryAddress.deliveryAddressLine1.errors.required || fDeliveryAddress.deliveryAddressLine1.errors.whitespace">
                  {{ validationMessages.deliveryAddressLine1.required }}
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form__group full-width">
              <label class="form__label">Address Line 2</label>
              <!-- <textarea class="form__textarea" formControlName="deliveryAddressLine2" pInputTextarea></textarea> -->
              <input type="text" class="form__control" formControlName="deliveryAddressLine2" pInputText />
              <!--<div *ngIf="formDeliveryAddressSubmitted && fDeliveryAddress.deliveryAddressLine2.errors" class="invalid-feedback">
                <div *ngIf="fDeliveryAddress.deliveryAddressLine2.errors.required || fDeliveryAddress.deliveryAddressLine2.errors.whitespace">
                  {{validationMessages.deliveryAddressLine2.required}}
                </div>

              </div>-->
            </div>
          </div>
          <div class="col">
            <div class="form__group">
              <label class="form__label">City</label>
              <input type="text" class="form__control" formControlName="deliveryAddressCity" pInputText />
              <div *ngIf="formDeliveryAddressSubmitted && fDeliveryAddress.deliveryAddressCity.errors" class="invalid-feedback">
                <div *ngIf="fDeliveryAddress.deliveryAddressCity.errors.required || fDeliveryAddress.deliveryAddressCity.errors.whitespace">
                  {{ validationMessages.deliveryAddressCity.required }}
                </div>
              </div>
            </div>
            <div class="form__group">
              <label class="form__label">State</label>
              <p-select
                class="form__dropdown select-box"
                [options]="statsModel"
                [(ngModel)]="selectedState"
                placeholder="Select"
                formControlName="deliveryAddressState"
                optionLabel="appStateName"
                appendTo="body"
                filter="true"
              >
              </p-select>
              <div *ngIf="formDeliveryAddressSubmitted && fDeliveryAddress.deliveryAddressState.errors" class="invalid-feedback">
                <div *ngIf="fDeliveryAddress.deliveryAddressState.errors.required || fDeliveryAddress.deliveryAddressState.errors.whitespace">
                  {{ validationMessages.deliveryAddressState.required }}
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form__group">
              <label class="form__label">Zip Code</label>
              <input type="text" class="form__control" formControlName="deliveryAddressZipcode" pInputText maxlength="15" />
              <div *ngIf="formDeliveryAddressSubmitted && fDeliveryAddress.deliveryAddressZipcode.errors" class="invalid-feedback">
                <div *ngIf="fDeliveryAddress.deliveryAddressZipcode.errors.required || fDeliveryAddress.deliveryAddressZipcode.errors.whitespace">
                  {{ validationMessages.deliveryAddressZipcode.required }}
                </div>
                <div *ngIf="fDeliveryAddress.deliveryAddressZipcode.errors.validNumber">
                  {{ validationMessages.deliveryAddressZipcode.validNumber }}
                </div>
              </div>
            </div>
          </div>
          <div class="call-popup-appointment">
            <button class="btn btn--primary" (click)="UpdateDeliveryAddress()">Submit</button>
            <a href="javascript:void(0)" class="btn btn--secondary" (click)="cancelDeliveryAddress()">Cancel</a>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="loader-block" *ngIf="loadingDeliveryAddress" style="z-index: 99999999 !important">
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="8" fill="#ffffff" animationDuration=".8s"> </p-progressSpinner>
  </div>
</p-dialog>
<!-- Delivery Note Popup-->
<p-dialog [(visible)]="displayDeliveryNote" styleClass="display-close-icon" [modal]="true" appendTo="body" [baseZIndex]="9999999">
  <div class="search-box-outer delivery">
    <h2 class="filter-title" style="padding: 0">Delivery Note</h2>

    <div class="form__group order-note">
      <textarea class="form__textarea" maxlength="500" [(ngModel)]="crmSalesorderDeliveryNote" pInputTextarea></textarea>
    </div>

    <div class="btn-block app-not-scheduled-appointments-btn">
      <button class="btn btn--primary" (click)="SaveDeliveryNoteBTClick()">Save</button>
      <a class="btn btn--secondary clear-filter" href="javascript:void(0)" (click)="CancelDeliveryNoteBTClick()"> Cancel </a>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="displayHangUpConfirm" styleClass="display-close-icon" [modal]="true" appendTo="body" [baseZIndex]="9999999">
  <div class="search-box-outer delivery">
    <h2 class="filter-title" style="padding: 0">Voice Call</h2>
    <div class="form__group order-note">
      <p>Voice calls in progress. Do you want to hang up the call?</p>
    </div>
    <div class="btn-block app-not-scheduled-appointments-btn">
      <button class="btn btn--primary" (click)="Hangup()">Yes</button>
      <button class="btn btn--primary" (click)="CancelHangUp()">No</button>
    </div>
  </div>
</p-dialog>

<div class="loader-block" *ngIf="loading" style="z-index: 99999999 !important">
  <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="8" fill="#ffffff" animationDuration=".8s"> </p-progressSpinner>
</div>

<div class="loader-block" *ngIf="loadingCustom" style="z-index: 99999999 !important">
  <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="8" fill="#ffffff" animationDuration=".8s"> </p-progressSpinner>
</div>

<!-- SMS Log Popup-->
<p-dialog [(visible)]="smsdisplay" appendTo="body" [modal]="true">
  <div class="sms-log-popup-outer">
    <div class="popup-title">
      <h2>SMS Logs ({{ appointmentSMSHistoryResponseModel.length }})</h2>
    </div>
    <div class="sms-popup-content">
      <ul class="sms-popup-content__list">
        <li
          class="sms-popup-content__item"
          [ngClass]="$index == expandedIndex ? 'active' : ''"
          *ngFor="let appointmentSMSHistory of appointmentSMSHistoryResponseModel; let $index = index"
        >
          <div class="item-header">
            <div class="item-header__left">
              <h3>{{ formatString(appointmentSMSHistory.appNotificationSubject) }}</h3>
              <p>
                Sent to {{ appointmentSMSHistory.appNotificationSmstoNumber | phone }}
                on
                {{ appointmentSMSHistory.appNotificationSmssentTime | date : appDateFormat.dateFormat }}
                at
                {{ appointmentSMSHistory.appNotificationSmssentTime | date : 'shortTime' | lowercase }}
              </p>
            </div>
            <div class="item-header__right">
              <a (click)="Collapse($index)" href="javascript:void(0)">
                {{ $index == expandedIndex ? 'Hide Message' : 'Show Message' }}
              </a>
            </div>
          </div>
          <div class="item-content" *ngIf="$index == expandedIndex">
            <p>{{ appointmentSMSHistory.appNotificationSmsbody }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="loader-block" *ngIf="loadingEmail">
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="8" fill="#ffffff" animationDuration=".8s"> </p-progressSpinner>
  </div>
</p-dialog>

<!-- Email Log Popup-->
<p-dialog [(visible)]="emaildisplay" appendTo="body" [modal]="true">
  <div class="sms-log-popup-outer">
    <div class="popup-title">
      <h2>Email Logs ({{ appointmentEmailHistoryResponseModel.length }})</h2>
    </div>
    <div class="sms-popup-content">
      <ul class="sms-popup-content__list email-list">
        <li class="sms-popup-content__item" *ngFor="let appointmentEmailHistory of appointmentEmailHistoryResponseModel; let i = index">
          <div class="item-header">
            <div class="item-header__left">
              <h3>{{ formatString(appointmentEmailHistory.appEmailsubject) }}</h3>
            </div>
            <div class="item-header__right">
              {{ appointmentEmailHistory.appNotificationEmailSentTime | date : appDateFormat.dateFormat }}
              {{ appointmentEmailHistory.appNotificationEmailSentTime | date : 'shortTime' | lowercase }}
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="loader-block" *ngIf="loadingEmail">
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="8" fill="#ffffff" animationDuration=".8s"> </p-progressSpinner>
  </div>
</p-dialog>

<!-- Remap UI for SMS Log -->
<p-sidebar [(visible)]="SMSSidebarDisplay" styleClass="email-sms-sidebar-outer z-index-999999" position="right" appendTo="body" maskStyle="z-index: 999999 !important">
  <app-sms-logs
    [appointmentSMSHistoryResponseModel]="appointmentSMSHistoryResponseModel"
    [schIsReminderOptedSms]="appointment.schIsReminderOptedSms"
    [isAppointment]="true"
    [schAppointmentId]="schAppointmentId"
  ></app-sms-logs>
</p-sidebar>

<!-- Remap UI for EMail Log -->
<p-sidebar [(visible)]="EmailSidebarDisplay" styleClass="email-sms-sidebar-outer z-index-999999" position="right" appendTo="body" maskStyle="z-index: 999999 !important">
  <app-email-logs
    [appointmentEmailHistoryResponseModel]="appointmentEmailHistoryResponseModel"
    [schIsReminderOptedEmail]="appointment.schIsReminderOptedEmail"
    [isAppointment]="true"
    [schAppointmentId]="schAppointmentId"
  ></app-email-logs>
</p-sidebar>
